"use strict";
module.exports = {
    Afrika: {
        name: 'Afrika',
        localizedName: 'Afrika',
        desciption: '',
        children: {
            Algeriet: {
                name: 'Algeriet',
                localizedName: 'Algeriet',
                desciption: '',
            },
            Angola: {
                name: 'Angola',
                localizedName: 'Angola',
                desciption: '',
            },
            Benin: {
                name: 'Benin',
                localizedName: 'Benin',
                desciption: '',
            },
            Botswana: {
                name: 'Botswana',
                localizedName: 'Botswana',
                desciption: '',
            },
            'Burkina Faso': {
                name: 'Burkina Faso',
                localizedName: 'Burkina Faso',
                desciption: '',
            },
            Burundi: {
                name: 'Burundi',
                localizedName: 'Burundi',
                desciption: '',
            },
            Calitzdorp: {
                name: 'Calitzdorp',
                localizedName: 'Calitzdorp',
                desciption: '',
            },
            'Centralafrikanska republiken': {
                name: 'Centralafrikanska republiken',
                localizedName: 'Centralafrikanska republiken',
                desciption: '',
            },
            'Demokratiska republiken Kongo': {
                name: 'Demokratiska republiken Kongo',
                localizedName: 'Demokratiska republiken Kongo',
                desciption: '',
            },
            Djibouti: {
                name: 'Djibouti',
                localizedName: 'Djibouti',
                desciption: '',
            },
            Egypten: {
                name: 'Egypten',
                localizedName: 'Egypten',
                desciption: '',
            },
            Ekvatorialguinea: {
                name: 'Ekvatorialguinea',
                localizedName: 'Ekvatorialguinea',
                desciption: '',
            },
            Elfenbenskusten: {
                name: 'Elfenbenskusten',
                localizedName: 'Elfenbenskusten',
                desciption: '',
            },
            Eritrea: {
                name: 'Eritrea',
                localizedName: 'Eritrea',
                desciption: '',
            },
            Etiopien: {
                name: 'Etiopien',
                localizedName: 'Etiopien',
                desciption: '',
            },
            Gabon: {
                name: 'Gabon',
                localizedName: 'Gabon',
                desciption: '',
            },
            Gambia: {
                name: 'Gambia',
                localizedName: 'Gambia',
                desciption: '',
            },
            Ghana: {
                name: 'Ghana',
                localizedName: 'Ghana',
                desciption: '',
            },
            Guinea: {
                name: 'Guinea',
                localizedName: 'Guinea',
                desciption: '',
            },
            Kamerun: {
                name: 'Kamerun',
                localizedName: 'Kamerun',
                desciption: '',
            },
            'Kap Verde': {
                name: 'Kap Verde',
                localizedName: 'Kap Verde',
                desciption: '',
            },
            Kenya: {
                name: 'Kenya',
                localizedName: 'Kenya',
                desciption: '',
            },
            Komorerna: {
                name: 'Komorerna',
                localizedName: 'Komorerna',
                desciption: '',
            },
            Lesotho: {
                name: 'Lesotho',
                localizedName: 'Lesotho',
                desciption: '',
            },
            Libanon: {
                name: 'Libanon',
                localizedName: 'Libanon',
                desciption: '',
            },
            Liberia: {
                name: 'Liberia',
                localizedName: 'Liberia',
                desciption: '',
            },
            Libyen: {
                name: 'Libyen',
                localizedName: 'Libyen',
                desciption: '',
            },
            Madagaskar: {
                name: 'Madagaskar',
                localizedName: 'Madagaskar',
                desciption: '',
            },
            Malawi: {
                name: 'Malawi',
                localizedName: 'Malawi',
                desciption: '',
            },
            Mali: {
                name: 'Mali',
                localizedName: 'Mali',
                desciption: '',
            },
            Marocko: {
                name: 'Marocko',
                localizedName: 'Marocko',
                desciption: '',
            },
            Mauretanien: {
                name: 'Mauretanien',
                localizedName: 'Mauretanien',
                desciption: '',
            },
            Mauritius: {
                name: 'Mauritius',
                localizedName: 'Mauritius',
                desciption: '',
            },
            Moçambique: {
                name: 'Moçambique',
                localizedName: 'Moçambique',
                desciption: '',
            },
            Namibia: {
                name: 'Namibia',
                localizedName: 'Namibia',
                desciption: '',
            },
            Niger: {
                name: 'Niger',
                localizedName: 'Niger',
                desciption: '',
            },
            Nigeria: {
                name: 'Nigeria',
                localizedName: 'Nigeria',
                desciption: '',
            },
            Outeniqua: {
                name: 'Outeniqua',
                localizedName: 'Outeniqua',
                desciption: '',
            },
            'Republiken Kongo': {
                name: 'Republiken Kongo',
                localizedName: 'Republiken Kongo',
                desciption: '',
            },
            Réunion: {
                name: 'Réunion',
                localizedName: 'Réunion',
                desciption: '',
                children: {
                    Réunion: {
                        name: 'Réunion',
                        localizedName: 'Réunion',
                        desciption: '',
                    },
                },
            },
            Rwanda: {
                name: 'Rwanda',
                localizedName: 'Rwanda',
                desciption: '',
            },
            'São Tomé och Príncipe': {
                name: 'São Tomé och Príncipe',
                localizedName: 'São Tomé och Príncipe',
                desciption: '',
            },
            Saudiarabien: {
                name: 'Saudiarabien',
                localizedName: 'Saudiarabien',
                desciption: '',
            },
            Senegal: {
                name: 'Senegal',
                localizedName: 'Senegal',
                desciption: '',
            },
            Seychellerna: {
                name: 'Seychellerna',
                localizedName: 'Seychellerna',
                desciption: '',
            },
            'Sierra Leone': {
                name: 'Sierra Leone',
                localizedName: 'Sierra Leone',
                desciption: '',
            },
            'Simonsberg-Paarl': {
                name: 'Simonsberg-Paarl',
                localizedName: 'Simonsberg-Paarl',
                desciption: '',
            },
            Somalia: {
                name: 'Somalia',
                localizedName: 'Somalia',
                desciption: '',
            },
            Sudan: {
                name: 'Sudan',
                localizedName: 'Sudan',
                desciption: '',
            },
            Swaziland: {
                name: 'Swaziland',
                localizedName: 'Swaziland',
                desciption: '',
            },
            Sydafrika: {
                name: 'Sydafrika',
                localizedName: 'Sydafrika',
                desciption: '',
                children: {
                    'Breede River Valley': {
                        name: 'Breede River Valley',
                        localizedName: 'Breede River Valley',
                        desciption: '',
                    },
                    'Cape South Coast': {
                        name: 'Cape South Coast',
                        localizedName: 'Cape South Coast',
                        desciption: '',
                    },
                    'Cape Town': {
                        name: 'Cape Town',
                        localizedName: 'Cape Town',
                        desciption: '',
                    },
                    'Coastal Region': {
                        name: 'Coastal Region',
                        localizedName: 'Coastal Region',
                        desciption: '',
                        children: {
                            'Cape Point': {
                                name: 'Cape Point',
                                localizedName: 'Cape Point',
                                desciption: '',
                            },
                            Darling: {
                                name: 'Darling',
                                localizedName: 'Darling',
                                desciption: '',
                            },
                            Franschhoek: {
                                name: 'Franschhoek',
                                localizedName: 'Franschhoek',
                                desciption: '',
                            },
                            Paarl: {
                                name: 'Paarl',
                                localizedName: 'Paarl',
                                desciption: '',
                            },
                            Stellenbosch: {
                                name: 'Stellenbosch',
                                localizedName: 'Stellenbosch',
                                desciption: '',
                            },
                            Swartland: {
                                name: 'Swartland',
                                localizedName: 'Swartland',
                                desciption: '',
                            },
                            Tulbagh: {
                                name: 'Tulbagh',
                                localizedName: 'Tulbagh',
                                desciption: '',
                            },
                            Tygerberg: {
                                name: 'Tygerberg',
                                localizedName: 'Tygerberg',
                                desciption: '',
                            },
                        },
                    },
                    'Eastern Cape': {
                        name: 'Eastern Cape',
                        localizedName: 'Eastern Cape',
                        desciption: '',
                    },
                    Elim: {
                        name: 'Elim',
                        localizedName: 'Elim',
                        desciption: '',
                    },
                    'Hemel en Aarde Ridge': {
                        name: 'Hemel en Aarde Ridge',
                        localizedName: 'Hemel en Aarde Ridge',
                        desciption: '',
                    },
                    'Klein Karoo': {
                        name: 'Klein Karoo',
                        localizedName: 'Klein Karoo',
                        desciption: '',
                    },
                    'Nothern Cape': {
                        name: 'Nothern Cape',
                        localizedName: 'Nothern Cape',
                        desciption: '',
                    },
                    'Olifants River': {
                        name: 'Olifants River',
                        localizedName: 'Olifants River',
                        desciption: '',
                    },
                    Robertson: {
                        name: 'Robertson',
                        localizedName: 'Robertson',
                        desciption: '',
                    },
                    'Western Cape': {
                        name: 'Western Cape',
                        localizedName: 'Western Cape',
                        desciption: '',
                        children: {
                            'Walker bay': {
                                name: 'Walker bay',
                                localizedName: 'Walker bay',
                                desciption: '',
                                children: {
                                    'Hemel-en-Aarde Ridge': {
                                        name: 'Hemel-en-Aarde Ridge',
                                        localizedName: 'Hemel-en-Aarde Ridge',
                                        desciption: '',
                                    },
                                },
                            },
                        },
                    },
                },
            },
            Tanzania: {
                name: 'Tanzania',
                localizedName: 'Tanzania',
                desciption: '',
            },
            Tchad: {
                name: 'Tchad',
                localizedName: 'Tchad',
                desciption: '',
            },
            Togo: {
                name: 'Togo',
                localizedName: 'Togo',
                desciption: '',
            },
            Tunisien: {
                name: 'Tunisien',
                localizedName: 'Tunisien',
                desciption: '',
            },
            Uganda: {
                name: 'Uganda',
                localizedName: 'Uganda',
                desciption: '',
            },
            Zambia: {
                name: 'Zambia',
                localizedName: 'Zambia',
                desciption: '',
            },
            Zimbabwe: {
                name: 'Zimbabwe',
                localizedName: 'Zimbabwe',
                desciption: '',
            },
        },
    },
    Antarktis: {
        name: 'Antarktis',
        localizedName: 'Antarktis',
        desciption: '',
        children: {
            'Franska sydterritorierna': {
                name: 'Franska sydterritorierna',
                localizedName: 'Franska sydterritorierna',
                desciption: '',
                children: {
                    'Franska sydterritorierna': {
                        name: 'Franska sydterritorierna',
                        localizedName: 'Franska sydterritorierna',
                        desciption: '',
                    },
                },
            },
        },
    },
    Asien: {
        name: 'Asien',
        localizedName: 'Asien',
        desciption: '',
        children: {
            Afghanistan: {
                name: 'Afghanistan',
                localizedName: 'Afghanistan',
                desciption: '',
            },
            Armenien: {
                name: 'Armenien',
                localizedName: 'Armenien',
                desciption: '',
            },
            Azerbajdzjan: {
                name: 'Azerbajdzjan',
                localizedName: 'Azerbajdzjan',
                desciption: '',
            },
            Bahrain: {
                name: 'Bahrain',
                localizedName: 'Bahrain',
                desciption: '',
            },
            Bangladesh: {
                name: 'Bangladesh',
                localizedName: 'Bangladesh',
                desciption: '',
            },
            Belize: {
                name: 'Belize',
                localizedName: 'Belize',
                desciption: '',
            },
            Bhutan: {
                name: 'Bhutan',
                localizedName: 'Bhutan',
                desciption: '',
            },
            Brunei: {
                name: 'Brunei',
                localizedName: 'Brunei',
                desciption: '',
            },
            Filippinerna: {
                name: 'Filippinerna',
                localizedName: 'Filippinerna',
                desciption: '',
            },
            'Förenade arabemiraten': {
                name: 'Förenade arabemiraten',
                localizedName: 'Förenade arabemiraten',
                desciption: '',
            },
            Georgien: {
                name: 'Georgien',
                localizedName: 'Georgien',
                desciption: '',
                children: {
                    Mukuzani: {
                        name: 'Mukuzani',
                        localizedName: 'Mukuzani',
                        desciption: '',
                    },
                },
            },
            Hongkong: {
                name: 'Hongkong',
                localizedName: 'Hongkong',
                desciption: '',
            },
            Indien: {
                name: 'Indien',
                localizedName: 'Indien',
                desciption: '',
            },
            Indonesien: {
                name: 'Indonesien',
                localizedName: 'Indonesien',
                desciption: '',
            },
            Irak: {
                name: 'Irak',
                localizedName: 'Irak',
                desciption: '',
            },
            Iran: {
                name: 'Iran',
                localizedName: 'Iran',
                desciption: '',
            },
            Israel: {
                name: 'Israel',
                localizedName: 'Israel',
                desciption: '',
            },
            Japan: {
                name: 'Japan',
                localizedName: 'Japan',
                desciption: '',
                children: {
                    Aichi: {
                        name: 'Aichi',
                        localizedName: 'Aichi',
                        desciption: '',
                    },
                    Akita: {
                        name: 'Akita',
                        localizedName: 'Akita',
                        desciption: '',
                    },
                    Aomori: {
                        name: 'Aomori',
                        localizedName: 'Aomori',
                        desciption: '',
                    },
                    Chiba: {
                        name: 'Chiba',
                        localizedName: 'Chiba',
                        desciption: '',
                    },
                    Ehime: {
                        name: 'Ehime',
                        localizedName: 'Ehime',
                        desciption: '',
                    },
                    Fukui: {
                        name: 'Fukui',
                        localizedName: 'Fukui',
                        desciption: '',
                    },
                    Fukuoka: {
                        name: 'Fukuoka',
                        localizedName: 'Fukuoka',
                        desciption: '',
                    },
                    Fukushima: {
                        name: 'Fukushima',
                        localizedName: 'Fukushima',
                        desciption: '',
                    },
                    Gifu: {
                        name: 'Gifu',
                        localizedName: 'Gifu',
                        desciption: '',
                    },
                    Gunma: {
                        name: 'Gunma',
                        localizedName: 'Gunma',
                        desciption: '',
                    },
                    Hiroshima: {
                        name: 'Hiroshima',
                        localizedName: 'Hiroshima',
                        desciption: '',
                    },
                    Hokkaido: {
                        name: 'Hokkaido',
                        localizedName: 'Hokkaido',
                        desciption: '',
                    },
                    Hyogo: {
                        name: 'Hyogo',
                        localizedName: 'Hyogo',
                        desciption: '',
                    },
                    Ibaraki: {
                        name: 'Ibaraki',
                        localizedName: 'Ibaraki',
                        desciption: '',
                    },
                    Ishikawa: {
                        name: 'Ishikawa',
                        localizedName: 'Ishikawa',
                        desciption: '',
                    },
                    Iwate: {
                        name: 'Iwate',
                        localizedName: 'Iwate',
                        desciption: '',
                    },
                    Kagawa: {
                        name: 'Kagawa',
                        localizedName: 'Kagawa',
                        desciption: '',
                    },
                    Kagoshima: {
                        name: 'Kagoshima',
                        localizedName: 'Kagoshima',
                        desciption: '',
                    },
                    Kanagawa: {
                        name: 'Kanagawa',
                        localizedName: 'Kanagawa',
                        desciption: '',
                    },
                    Kochi: {
                        name: 'Kochi',
                        localizedName: 'Kochi',
                        desciption: '',
                    },
                    Kumamoto: {
                        name: 'Kumamoto',
                        localizedName: 'Kumamoto',
                        desciption: '',
                    },
                    Kyoto: {
                        name: 'Kyoto',
                        localizedName: 'Kyoto',
                        desciption: '',
                    },
                    Mie: {
                        name: 'Mie',
                        localizedName: 'Mie',
                        desciption: '',
                    },
                    Miyagi: {
                        name: 'Miyagi',
                        localizedName: 'Miyagi',
                        desciption: '',
                    },
                    Miyazaki: {
                        name: 'Miyazaki',
                        localizedName: 'Miyazaki',
                        desciption: '',
                    },
                    Nagano: {
                        name: 'Nagano',
                        localizedName: 'Nagano',
                        desciption: '',
                    },
                    Nagasaki: {
                        name: 'Nagasaki',
                        localizedName: 'Nagasaki',
                        desciption: '',
                    },
                    Nara: {
                        name: 'Nara',
                        localizedName: 'Nara',
                        desciption: '',
                    },
                    Niigata: {
                        name: 'Niigata',
                        localizedName: 'Niigata',
                        desciption: '',
                    },
                    Oita: {
                        name: 'Oita',
                        localizedName: 'Oita',
                        desciption: '',
                    },
                    Okayama: {
                        name: 'Okayama',
                        localizedName: 'Okayama',
                        desciption: '',
                    },
                    Okinawa: {
                        name: 'Okinawa',
                        localizedName: 'Okinawa',
                        desciption: '',
                    },
                    Osaka: {
                        name: 'Osaka',
                        localizedName: 'Osaka',
                        desciption: '',
                    },
                    Saga: {
                        name: 'Saga',
                        localizedName: 'Saga',
                        desciption: '',
                    },
                    Saitama: {
                        name: 'Saitama',
                        localizedName: 'Saitama',
                        desciption: '',
                    },
                    Shiga: {
                        name: 'Shiga',
                        localizedName: 'Shiga',
                        desciption: '',
                    },
                    Shimane: {
                        name: 'Shimane',
                        localizedName: 'Shimane',
                        desciption: '',
                    },
                    Shizuoka: {
                        name: 'Shizuoka',
                        localizedName: 'Shizuoka',
                        desciption: '',
                    },
                    Tochigi: {
                        name: 'Tochigi',
                        localizedName: 'Tochigi',
                        desciption: '',
                    },
                    Tokushima: {
                        name: 'Tokushima',
                        localizedName: 'Tokushima',
                        desciption: '',
                    },
                    Tokyo: {
                        name: 'Tokyo',
                        localizedName: 'Tokyo',
                        desciption: '',
                    },
                    Tottori: {
                        name: 'Tottori',
                        localizedName: 'Tottori',
                        desciption: '',
                    },
                    Toyama: {
                        name: 'Toyama',
                        localizedName: 'Toyama',
                        desciption: '',
                    },
                    Wakayama: {
                        name: 'Wakayama',
                        localizedName: 'Wakayama',
                        desciption: '',
                    },
                    Yamagata: {
                        name: 'Yamagata',
                        localizedName: 'Yamagata',
                        desciption: '',
                    },
                    Yamaguchi: {
                        name: 'Yamaguchi',
                        localizedName: 'Yamaguchi',
                        desciption: '',
                    },
                    Yamanashi: {
                        name: 'Yamanashi',
                        localizedName: 'Yamanashi',
                        desciption: '',
                    },
                },
            },
            Jordanien: {
                name: 'Jordanien',
                localizedName: 'Jordanien',
                desciption: '',
            },
            Kambodja: {
                name: 'Kambodja',
                localizedName: 'Kambodja',
                desciption: '',
            },
            Kazakstan: {
                name: 'Kazakstan',
                localizedName: 'Kazakstan',
                desciption: '',
            },
            Kina: {
                name: 'Kina',
                localizedName: 'Kina',
                desciption: '',
            },
            'Kina/Sydkorea': {
                name: 'Kina/Sydkorea',
                localizedName: 'Kina/Sydkorea',
                desciption: '',
                children: {
                    'CN/KR': {
                        name: 'CN/KR',
                        localizedName: 'CN/KR',
                        desciption: '',
                    },
                },
            },
            Kirgizistan: {
                name: 'Kirgizistan',
                localizedName: 'Kirgizistan',
                desciption: '',
            },
            Kuwait: {
                name: 'Kuwait',
                localizedName: 'Kuwait',
                desciption: '',
            },
            Laos: {
                name: 'Laos',
                localizedName: 'Laos',
                desciption: '',
            },
            Libanon: {
                name: 'Libanon',
                localizedName: 'Libanon',
                desciption: '',
            },
            Malaysia: {
                name: 'Malaysia',
                localizedName: 'Malaysia',
                desciption: '',
            },
            Maldiverna: {
                name: 'Maldiverna',
                localizedName: 'Maldiverna',
                desciption: '',
            },
            Mongoliet: {
                name: 'Mongoliet',
                localizedName: 'Mongoliet',
                desciption: '',
            },
            Myanmar: {
                name: 'Myanmar',
                localizedName: 'Myanmar',
                desciption: '',
            },
            Nepal: {
                name: 'Nepal',
                localizedName: 'Nepal',
                desciption: '',
            },
            Nordkorea: {
                name: 'Nordkorea',
                localizedName: 'Nordkorea',
                desciption: '',
            },
            Oman: {
                name: 'Oman',
                localizedName: 'Oman',
                desciption: '',
            },
            Östtimor: {
                name: 'Östtimor',
                localizedName: 'Östtimor',
                desciption: '',
            },
            Pakistan: {
                name: 'Pakistan',
                localizedName: 'Pakistan',
                desciption: '',
            },
            Palestina: {
                name: 'Palestina',
                localizedName: 'Palestina',
                desciption: '',
            },
            Qatar: {
                name: 'Qatar',
                localizedName: 'Qatar',
                desciption: '',
            },
            Singapore: {
                name: 'Singapore',
                localizedName: 'Singapore',
                desciption: '',
            },
            'Sri Lanka': {
                name: 'Sri Lanka',
                localizedName: 'Sri Lanka',
                desciption: '',
            },
            Sydkorea: {
                name: 'Sydkorea',
                localizedName: 'Sydkorea',
                desciption: '',
            },
            Syrien: {
                name: 'Syrien',
                localizedName: 'Syrien',
                desciption: '',
            },
            Tadzjikistan: {
                name: 'Tadzjikistan',
                localizedName: 'Tadzjikistan',
                desciption: '',
            },
            Taiwan: {
                name: 'Taiwan',
                localizedName: 'Taiwan',
                desciption: '',
            },
            Thailand: {
                name: 'Thailand',
                localizedName: 'Thailand',
                desciption: '',
                children: {
                    'Asoke Valley': {
                        name: 'Asoke Valley',
                        localizedName: 'Asoke Valley',
                        desciption: '',
                    },
                },
            },
            Turkmenistan: {
                name: 'Turkmenistan',
                localizedName: 'Turkmenistan',
                desciption: '',
            },
            Uzbekistan: {
                name: 'Uzbekistan',
                localizedName: 'Uzbekistan',
                desciption: '',
            },
            Vietnam: {
                name: 'Vietnam',
                localizedName: 'Vietnam',
                desciption: '',
            },
            Yemen: {
                name: 'Yemen',
                localizedName: 'Yemen',
                desciption: '',
            },
        },
    },
    Atlanten: {
        name: 'Atlanten',
        localizedName: 'Atlanten',
        desciption: '',
        children: {
            Atlanten: {
                name: 'Atlanten',
                localizedName: 'Atlanten',
                desciption: '',
                children: {
                    Atlanten: {
                        name: 'Atlanten',
                        localizedName: 'Atlanten',
                        desciption: '',
                    },
                },
            },
        },
    },
    Centralamerika: {
        name: 'Centralamerika',
        localizedName: 'Centralamerika',
        desciption: '',
        children: {
            'Costa Rica': {
                name: 'Costa Rica',
                localizedName: 'Costa Rica',
                desciption: '',
            },
            'El Salvador': {
                name: 'El Salvador',
                localizedName: 'El Salvador',
                desciption: '',
            },
            Honduras: {
                name: 'Honduras',
                localizedName: 'Honduras',
                desciption: '',
            },
            Nicaragua: {
                name: 'Nicaragua',
                localizedName: 'Nicaragua',
                desciption: '',
            },
            Panama: {
                name: 'Panama',
                localizedName: 'Panama',
                desciption: '',
            },
        },
    },
    Europa: {
        name: 'Europa',
        localizedName: 'Europa',
        desciption: '',
        children: {
            Albanien: {
                name: 'Albanien',
                localizedName: 'Albanien',
                desciption: '',
            },
            Andorra: {
                name: 'Andorra',
                localizedName: 'Andorra',
                desciption: '',
            },
            Belarus: {
                name: 'Belarus',
                localizedName: 'Belarus',
                desciption: '',
            },
            Belgien: {
                name: 'Belgien',
                localizedName: 'Belgien',
                desciption: '',
            },
            'Bosnien och Hercegovina': {
                name: 'Bosnien och Hercegovina',
                localizedName: 'Bosnien och Hercegovina',
                desciption: '',
            },
            Bulgarien: {
                name: 'Bulgarien',
                localizedName: 'Bulgarien',
                desciption: '',
            },
            Cypern: {
                name: 'Cypern',
                localizedName: 'Cypern',
                desciption: '',
            },
            Danmark: {
                name: 'Danmark',
                localizedName: 'Danmark',
                desciption: '',
                children: {
                    Färöarna: {
                        name: 'Färöarna',
                        localizedName: 'Färöarna',
                        desciption: '',
                    },
                    Gråsten: {
                        name: 'Gråsten',
                        localizedName: 'Gråsten',
                        desciption: '',
                    },
                },
            },
            EU: {
                name: 'EU',
                localizedName: 'EU',
                desciption: '',
            },
            England: {
                name: 'England',
                localizedName: 'England',
                desciption: '',
            },
            Estland: {
                name: 'Estland',
                localizedName: 'Estland',
                desciption: '',
            },
            Finland: {
                name: 'Finland',
                localizedName: 'Finland',
                desciption: '',
                children: {
                    Åland: {
                        name: 'Åland',
                        localizedName: 'Åland',
                        desciption: '',
                    },
                    Lapland: {
                        name: 'Lapland',
                        localizedName: 'Lapland',
                        desciption: '',
                    },
                },
            },
            Frankrike: {
                name: 'Frankrike',
                localizedName: 'Frankrike',
                desciption: '',
                children: {
                    Alsace: {
                        name: 'Alsace',
                        localizedName: 'Alsace',
                        desciption: '',
                        children: {
                            'Bas-Rhin': {
                                name: 'Bas-Rhin',
                                localizedName: 'Bas-Rhin',
                                desciption: '',
                            },
                            'Haut-Rhin': {
                                name: 'Haut-Rhin',
                                localizedName: 'Haut-Rhin',
                                desciption: '',
                            },
                        },
                    },
                    Armangac: {
                        name: 'Armangac',
                        localizedName: 'Armangac',
                        desciption: '',
                    },
                    Bergerac: {
                        name: 'Bergerac',
                        localizedName: 'Bergerac',
                        desciption: '',
                    },
                    'Bordeaux- Haut Médoc': {
                        name: 'Bordeaux- Haut Médoc',
                        localizedName: 'Bordeaux- Haut Médoc',
                        desciption: '',
                    },
                    Bordeaux: {
                        name: 'Bordeaux',
                        localizedName: 'Bordeaux',
                        desciption: '',
                        children: {
                            Barsac: {
                                name: 'Barsac',
                                localizedName: 'Barsac',
                                desciption: '',
                            },
                            'Entre-Deux-Mers': {
                                name: 'Entre-Deux-Mers',
                                localizedName: 'Entre-Deux-Mers',
                                desciption: '',
                            },
                            Fronsac: {
                                name: 'Fronsac',
                                localizedName: 'Fronsac',
                                desciption: '',
                            },
                            'Graves & Pessac-Léognan': {
                                name: 'Graves & Pessac-Léognan',
                                localizedName: 'Graves & Pessac-Léognan',
                                desciption: '',
                            },
                            'Haut-Médoc': {
                                name: 'Haut-Médoc',
                                localizedName: 'Haut-Médoc',
                                desciption: '',
                            },
                            Margaux: {
                                name: 'Margaux',
                                localizedName: 'Margaux',
                                desciption: '',
                            },
                            Médoc: {
                                name: 'Médoc',
                                localizedName: 'Médoc',
                                desciption: '',
                            },
                            Pauillac: {
                                name: 'Pauillac',
                                localizedName: 'Pauillac',
                                desciption: '',
                            },
                            'Pessac-Léognan': {
                                name: 'Pessac-Léognan',
                                localizedName: 'Pessac-Léognan',
                                desciption: '',
                            },
                            'Pomerol och St Emilion': {
                                name: 'Pomerol och St Emilion',
                                localizedName: 'Pomerol och St Emilion',
                                desciption: '',
                            },
                            'Saint-Estèphe': {
                                name: 'Saint-Estèphe',
                                localizedName: 'Saint-Estèphe',
                                desciption: '',
                            },
                            'Saint-Julien': {
                                name: 'Saint-Julien',
                                localizedName: 'Saint-Julien',
                                desciption: '',
                            },
                            Sauternes: {
                                name: 'Sauternes',
                                localizedName: 'Sauternes',
                                desciption: '',
                            },
                        },
                    },
                    Bourgogne: {
                        name: 'Bourgogne',
                        localizedName: 'Bourgogne',
                        desciption: '',
                        children: {
                            Beaujolais: {
                                name: 'Beaujolais',
                                localizedName: 'Beaujolais',
                                desciption: '',
                                children: {
                                    Brouilly: {
                                        name: 'Brouilly',
                                        localizedName: 'Brouilly',
                                        desciption: '',
                                    },
                                    Chénas: {
                                        name: 'Chénas',
                                        localizedName: 'Chénas',
                                        desciption: '',
                                    },
                                    Chiroubles: {
                                        name: 'Chiroubles',
                                        localizedName: 'Chiroubles',
                                        desciption: '',
                                    },
                                    'Côte de Brouilly': {
                                        name: 'Côte de Brouilly',
                                        localizedName: 'Côte de Brouilly',
                                        desciption: '',
                                    },
                                    Fleurie: {
                                        name: 'Fleurie',
                                        localizedName: 'Fleurie',
                                        desciption: '',
                                    },
                                    Juliénas: {
                                        name: 'Juliénas',
                                        localizedName: 'Juliénas',
                                        desciption: '',
                                    },
                                    Morgon: {
                                        name: 'Morgon',
                                        localizedName: 'Morgon',
                                        desciption: '',
                                    },
                                    'Moulin à vent': {
                                        name: 'Moulin à vent',
                                        localizedName: 'Moulin à vent',
                                        desciption: '',
                                    },
                                    Régnié: {
                                        name: 'Régnié',
                                        localizedName: 'Régnié',
                                        desciption: '',
                                    },
                                    'Saint-Amour': {
                                        name: 'Saint-Amour',
                                        localizedName: 'Saint-Amour',
                                        desciption: '',
                                    },
                                },
                            },
                            Chablis: {
                                name: 'Chablis',
                                localizedName: 'Chablis',
                                desciption: '',
                            },
                            'Côte Chalonnaise': {
                                name: 'Côte Chalonnaise',
                                localizedName: 'Côte Chalonnaise',
                                desciption: '',
                            },
                            "Côte d'Or": {
                                name: "Côte d'Or",
                                localizedName: "Côte d'Or",
                                desciption: '',
                                children: {
                                    'Côte de Beaune': {
                                        name: 'Côte de Beaune',
                                        localizedName: 'Côte de Beaune',
                                        desciption: '',
                                        children: {
                                            'Aloxe-Corton': {
                                                name: 'Aloxe-Corton',
                                                localizedName: 'Aloxe-Corton',
                                                desciption: '',
                                            },
                                            'Auxey-Duresses': {
                                                name: 'Auxey-Duresses',
                                                localizedName: 'Auxey-Duresses',
                                                desciption: '',
                                            },
                                            Beaune: {
                                                name: 'Beaune',
                                                localizedName: 'Beaune',
                                                desciption: '',
                                            },
                                            'Chassagne-Montrachet': {
                                                name: 'Chassagne-Montrachet',
                                                localizedName: 'Chassagne-Montrachet',
                                                desciption: '',
                                            },
                                            Meursault: {
                                                name: 'Meursault',
                                                localizedName: 'Meursault',
                                                desciption: '',
                                            },
                                            Santenay: {
                                                name: 'Santenay',
                                                localizedName: 'Santenay',
                                                desciption: '',
                                            },
                                        },
                                    },
                                    'Côte de Nuits': {
                                        name: 'Côte de Nuits',
                                        localizedName: 'Côte de Nuits',
                                        desciption: '',
                                        children: {
                                            'Chambolle-Musigny': {
                                                name: 'Chambolle-Musigny',
                                                localizedName: 'Chambolle-Musigny',
                                                desciption: '',
                                            },
                                            'Gevrey-Chambertin': {
                                                name: 'Gevrey-Chambertin',
                                                localizedName: 'Gevrey-Chambertin',
                                                desciption: '',
                                            },
                                            'Nuits-Saint-Georges': {
                                                name: 'Nuits-Saint-Georges',
                                                localizedName: 'Nuits-Saint-Georges',
                                                desciption: '',
                                            },
                                            'Vosne-Romanée': {
                                                name: 'Vosne-Romanée',
                                                localizedName: 'Vosne-Romanée',
                                                desciption: '',
                                            },
                                        },
                                    },
                                },
                            },
                            Mâconnais: {
                                name: 'Mâconnais',
                                localizedName: 'Mâconnais',
                                desciption: '',
                                children: {
                                    'Pouilly-Fuissé': {
                                        name: 'Pouilly-Fuissé',
                                        localizedName: 'Pouilly-Fuissé',
                                        desciption: '',
                                    },
                                },
                            },
                        },
                    },
                    Bretagne: {
                        name: 'Bretagne',
                        localizedName: 'Bretagne',
                        desciption: '',
                    },
                    Bugey: {
                        name: 'Bugey',
                        localizedName: 'Bugey',
                        desciption: '',
                    },
                    Burgundy: {
                        name: 'Burgundy',
                        localizedName: 'Burgundy',
                        desciption: '',
                    },
                    Champagne: {
                        name: 'Champagne',
                        localizedName: 'Champagne',
                        desciption: '',
                        children: {
                            'Côte des Blances': {
                                name: 'Côte des Blances',
                                localizedName: 'Côte des Blances',
                                desciption: '',
                            },
                            'Montagne de Reims': {
                                name: 'Montagne de Reims',
                                localizedName: 'Montagne de Reims',
                                desciption: '',
                            },
                            'Vallée de lar Marne': {
                                name: 'Vallée de lar Marne',
                                localizedName: 'Vallée de lar Marne',
                                desciption: '',
                            },
                        },
                    },
                    Corsica: {
                        name: 'Corsica',
                        localizedName: 'Corsica',
                        desciption: '',
                    },
                    'Côteaux Champenois': {
                        name: 'Côteaux Champenois',
                        localizedName: 'Côteaux Champenois',
                        desciption: '',
                    },
                    'Côtes de Gascogne': {
                        name: 'Côtes de Gascogne',
                        localizedName: 'Côtes de Gascogne',
                        desciption: '',
                    },
                    'Côtes de Provence': {
                        name: 'Côtes de Provence',
                        localizedName: 'Côtes de Provence',
                        desciption: '',
                    },
                    'Côtes du Roussillon Villages': {
                        name: 'Côtes du Roussillon Villages',
                        localizedName: 'Côtes du Roussillon Villages',
                        desciption: '',
                    },
                    'Côtes-du-Rhône Villages': {
                        name: 'Côtes-du-Rhône Villages',
                        localizedName: 'Côtes-du-Rhône Villages',
                        desciption: '',
                    },
                    'Côtes-du-Rhône': {
                        name: 'Côtes-du-Rhône',
                        localizedName: 'Côtes-du-Rhône',
                        desciption: '',
                    },
                    'Crémant de Alsace': {
                        name: 'Crémant de Alsace',
                        localizedName: 'Crémant de Alsace',
                        desciption: '',
                    },
                    'Crémant de Bourgogne': {
                        name: 'Crémant de Bourgogne',
                        localizedName: 'Crémant de Bourgogne',
                        desciption: '',
                    },
                    Dordogne: {
                        name: 'Dordogne',
                        localizedName: 'Dordogne',
                        desciption: '',
                    },
                    France: {
                        name: 'France',
                        localizedName: 'France',
                        desciption: '',
                    },
                    'Frankrike, Bourgogne': {
                        name: 'Frankrike, Bourgogne',
                        localizedName: 'Frankrike, Bourgogne',
                        desciption: '',
                    },
                    'Frankrike, Champagne': {
                        name: 'Frankrike, Champagne',
                        localizedName: 'Frankrike, Champagne',
                        desciption: '',
                    },
                    Gaillac: {
                        name: 'Gaillac',
                        localizedName: 'Gaillac',
                        desciption: '',
                    },
                    'IGP Côtes de Gascogne': {
                        name: 'IGP Côtes de Gascogne',
                        localizedName: 'IGP Côtes de Gascogne',
                        desciption: '',
                    },
                    'IGP Méditerrannée': {
                        name: 'IGP Méditerrannée',
                        localizedName: 'IGP Méditerrannée',
                        desciption: '',
                    },
                    'IGP Pays d´Oc': {
                        name: 'IGP Pays d´Oc',
                        localizedName: 'IGP Pays d´Oc',
                        desciption: '',
                    },
                    Irouleguy: {
                        name: 'Irouleguy',
                        localizedName: 'Irouleguy',
                        desciption: '',
                    },
                    Jura: {
                        name: 'Jura',
                        localizedName: 'Jura',
                        desciption: '',
                        children: {
                            Arbois: {
                                name: 'Arbois',
                                localizedName: 'Arbois',
                                desciption: '',
                            },
                            'Château-Chalon': {
                                name: 'Château-Chalon',
                                localizedName: 'Château-Chalon',
                                desciption: '',
                            },
                            'Côtes du Jura': {
                                name: 'Côtes du Jura',
                                localizedName: 'Côtes du Jura',
                                desciption: '',
                            },
                            'Crémant du Jura': {
                                name: 'Crémant du Jura',
                                localizedName: 'Crémant du Jura',
                                desciption: '',
                            },
                            "L'Étoile": {
                                name: "L'Étoile",
                                localizedName: "L'Étoile",
                                desciption: '',
                            },
                            'Macvin du Jura': {
                                name: 'Macvin du Jura',
                                localizedName: 'Macvin du Jura',
                                desciption: '',
                            },
                        },
                    },
                    Jurançon: {
                        name: 'Jurançon',
                        localizedName: 'Jurançon',
                        desciption: '',
                    },
                    Korsika: {
                        name: 'Korsika',
                        localizedName: 'Korsika',
                        desciption: '',
                        children: {
                            Ajaccio: {
                                name: 'Ajaccio',
                                localizedName: 'Ajaccio',
                                desciption: '',
                            },
                            'Cap Course': {
                                name: 'Cap Course',
                                localizedName: 'Cap Course',
                                desciption: '',
                            },
                            Patrimonio: {
                                name: 'Patrimonio',
                                localizedName: 'Patrimonio',
                                desciption: '',
                            },
                        },
                    },
                    'Languedoc-Roussillon': {
                        name: 'Languedoc-Roussillon',
                        localizedName: 'Languedoc-Roussillon',
                        desciption: '',
                        children: {
                            Banyuls: {
                                name: 'Banyuls',
                                localizedName: 'Banyuls',
                                desciption: '',
                            },
                            'Blanquette de Limoux': {
                                name: 'Blanquette de Limoux',
                                localizedName: 'Blanquette de Limoux',
                                desciption: '',
                            },
                            Cabardès: {
                                name: 'Cabardès',
                                localizedName: 'Cabardès',
                                desciption: '',
                            },
                            Collioure: {
                                name: 'Collioure',
                                localizedName: 'Collioure',
                                desciption: '',
                            },
                            Corbières: {
                                name: 'Corbières',
                                localizedName: 'Corbières',
                                desciption: '',
                            },
                            'Côtes du Roussillon': {
                                name: 'Côtes du Roussillon',
                                localizedName: 'Côtes du Roussillon',
                                desciption: '',
                            },
                            Fitou: {
                                name: 'Fitou',
                                localizedName: 'Fitou',
                                desciption: '',
                            },
                            Maury: {
                                name: 'Maury',
                                localizedName: 'Maury',
                                desciption: '',
                            },
                            Minervois: {
                                name: 'Minervois',
                                localizedName: 'Minervois',
                                desciption: '',
                            },
                            'Pays dOc': {
                                name: 'Pays dOc',
                                localizedName: 'Pays dOc',
                                desciption: '',
                            },
                            Rivesaltes: {
                                name: 'Rivesaltes',
                                localizedName: 'Rivesaltes',
                                desciption: '',
                            },
                        },
                    },
                    Languedoc: {
                        name: 'Languedoc',
                        localizedName: 'Languedoc',
                        desciption: '',
                    },
                    Lirac: {
                        name: 'Lirac',
                        localizedName: 'Lirac',
                        desciption: '',
                    },
                    'Loire,Anjou': {
                        name: 'Loire,Anjou',
                        localizedName: 'Loire,Anjou',
                        desciption: '',
                    },
                    Loire: {
                        name: 'Loire',
                        localizedName: 'Loire',
                        desciption: '',
                        children: {
                            'Anjou-Samur': {
                                name: 'Anjou-Samur',
                                localizedName: 'Anjou-Samur',
                                desciption: '',
                            },
                            Bourgueil: {
                                name: 'Bourgueil',
                                localizedName: 'Bourgueil',
                                desciption: '',
                            },
                            Chinon: {
                                name: 'Chinon',
                                localizedName: 'Chinon',
                                desciption: '',
                            },
                            'Coteaux du Layon': {
                                name: 'Coteaux du Layon',
                                localizedName: 'Coteaux du Layon',
                                desciption: '',
                            },
                            'Övre Loire': {
                                name: 'Övre Loire',
                                localizedName: 'Övre Loire',
                                desciption: '',
                            },
                            'Pays Nantais': {
                                name: 'Pays Nantais',
                                localizedName: 'Pays Nantais',
                                desciption: '',
                            },
                            Sancerre: {
                                name: 'Sancerre',
                                localizedName: 'Sancerre',
                                desciption: '',
                            },
                            'Saumur-Champigny': {
                                name: 'Saumur-Champigny',
                                localizedName: 'Saumur-Champigny',
                                desciption: '',
                            },
                            Saumur: {
                                name: 'Saumur',
                                localizedName: 'Saumur',
                                desciption: '',
                            },
                            Savennières: {
                                name: 'Savennières',
                                localizedName: 'Savennières',
                                desciption: '',
                            },
                            Touraine: {
                                name: 'Touraine',
                                localizedName: 'Touraine',
                                desciption: '',
                            },
                            Vouvray: {
                                name: 'Vouvray',
                                localizedName: 'Vouvray',
                                desciption: '',
                            },
                        },
                    },
                    'Lussac Saint-Émilion': {
                        name: 'Lussac Saint-Émilion',
                        localizedName: 'Lussac Saint-Émilion',
                        desciption: '',
                    },
                    Maconnais: {
                        name: 'Maconnais',
                        localizedName: 'Maconnais',
                        desciption: '',
                    },
                    Madiran: {
                        name: 'Madiran',
                        localizedName: 'Madiran',
                        desciption: '',
                    },
                    Normandie: {
                        name: 'Normandie',
                        localizedName: 'Normandie',
                        desciption: '',
                    },
                    Provence: {
                        name: 'Provence',
                        localizedName: 'Provence',
                        desciption: '',
                    },
                    Rhone: {
                        name: 'Rhone',
                        localizedName: 'Rhone',
                        desciption: '',
                        children: {
                            Ardèche: {
                                name: 'Ardèche',
                                localizedName: 'Ardèche',
                                desciption: '',
                            },
                            'Beaumes-de-Venise': {
                                name: 'Beaumes-de-Venise',
                                localizedName: 'Beaumes-de-Venise',
                                desciption: '',
                            },
                            'Château-Grillet': {
                                name: 'Château-Grillet',
                                localizedName: 'Château-Grillet',
                                desciption: '',
                            },
                            'Châteauneuf-du-Pape': {
                                name: 'Châteauneuf-du-Pape',
                                localizedName: 'Châteauneuf-du-Pape',
                                desciption: '',
                            },
                            Condrieu: {
                                name: 'Condrieu',
                                localizedName: 'Condrieu',
                                desciption: '',
                            },
                            Cornas: {
                                name: 'Cornas',
                                localizedName: 'Cornas',
                                desciption: '',
                            },
                            'Côte du Rhône-Villages, Rhône wine': {
                                name: 'Côte du Rhône-Villages, Rhône wine',
                                localizedName: 'Côte du Rhône-Villages, Rhône wine',
                                desciption: '',
                            },
                            'Côte du Rhône': {
                                name: 'Côte du Rhône',
                                localizedName: 'Côte du Rhône',
                                desciption: '',
                            },
                            'Côte-Rôtie': {
                                name: 'Côte-Rôtie',
                                localizedName: 'Côte-Rôtie',
                                desciption: '',
                            },
                            'Crozes-Hermitage': {
                                name: 'Crozes-Hermitage',
                                localizedName: 'Crozes-Hermitage',
                                desciption: '',
                            },
                            Gigondas: {
                                name: 'Gigondas',
                                localizedName: 'Gigondas',
                                desciption: '',
                            },
                            Hermitage: {
                                name: 'Hermitage',
                                localizedName: 'Hermitage',
                                desciption: '',
                            },
                            Rasteau: {
                                name: 'Rasteau',
                                localizedName: 'Rasteau',
                                desciption: '',
                            },
                            'Saint-Péray': {
                                name: 'Saint-Péray',
                                localizedName: 'Saint-Péray',
                                desciption: '',
                            },
                            St: {
                                ' Joseph': {
                                    name: 'St. Joseph',
                                    localizedName: 'St. Joseph',
                                    desciption: '',
                                },
                            },
                            Vacqueyras: {
                                name: 'Vacqueyras',
                                localizedName: 'Vacqueyras',
                                desciption: '',
                            },
                        },
                    },
                    Rhône: {
                        name: 'Rhône',
                        localizedName: 'Rhône',
                        desciption: '',
                    },
                    'Saint-Joseph': {
                        name: 'Saint-Joseph',
                        localizedName: 'Saint-Joseph',
                        desciption: '',
                    },
                    Savoie: {
                        name: 'Savoie',
                        localizedName: 'Savoie',
                        desciption: '',
                    },
                    Savoy: {
                        name: 'Savoy',
                        localizedName: 'Savoy',
                        desciption: '',
                        children: {
                            Fusette: {
                                name: 'Fusette',
                                localizedName: 'Fusette',
                                desciption: '',
                            },
                        },
                    },
                    'Södra Frankrike': {
                        name: 'Södra Frankrike',
                        localizedName: 'Södra Frankrike',
                        desciption: '',
                    },
                    'Sud-Ouest': {
                        name: 'Sud-Ouest',
                        localizedName: 'Sud-Ouest',
                        desciption: '',
                    },
                    'Vin de France': {
                        name: 'Vin de France',
                        localizedName: 'Vin de France',
                        desciption: '',
                    },
                },
            },
            Georgien: {
                name: 'Georgien',
                localizedName: 'Georgien',
                desciption: '',
            },
            Grekland: {
                name: 'Grekland',
                localizedName: 'Grekland',
                desciption: '',
                children: {
                    Attica: {
                        name: 'Attica',
                        localizedName: 'Attica',
                        desciption: '',
                    },
                    Santorini: {
                        name: 'Santorini',
                        localizedName: 'Santorini',
                        desciption: '',
                    },
                },
            },
            Irland: {
                name: 'Irland',
                localizedName: 'Irland',
                desciption: '',
            },
            Island: {
                name: 'Island',
                localizedName: 'Island',
                desciption: '',
            },
            Italien: {
                name: 'Italien',
                localizedName: 'Italien',
                desciption: '',
                children: {
                    Abruzzerna: {
                        name: 'Abruzzerna',
                        localizedName: 'Abruzzerna',
                        desciption: '',
                    },
                    Abruzzo: {
                        name: 'Abruzzo',
                        localizedName: 'Abruzzo',
                        desciption: '',
                    },
                    'Alto-Adige': {
                        name: 'Alto-Adige',
                        localizedName: 'Alto-Adige',
                        desciption: '',
                    },
                    AN: {
                        name: 'AN',
                        localizedName: 'AN',
                        desciption: '',
                    },
                    Apulien: {
                        name: 'Apulien',
                        localizedName: 'Apulien',
                        desciption: '',
                    },
                    Barba: {
                        name: 'Barba',
                        localizedName: 'Barba',
                        desciption: '',
                    },
                    "Barbera d'Alba": {
                        name: "Barbera d'Alba",
                        localizedName: "Barbera d'Alba",
                        desciption: '',
                    },
                    "Barbera d'Asti": {
                        name: "Barbera d'Asti",
                        localizedName: "Barbera d'Asti",
                        desciption: '',
                    },
                    'Barbera del Monferrato': {
                        name: 'Barbera del Monferrato',
                        localizedName: 'Barbera del Monferrato',
                        desciption: '',
                    },
                    Basilicata: {
                        name: 'Basilicata',
                        localizedName: 'Basilicata',
                        desciption: '',
                    },
                    'Brunello di Montalcino': {
                        name: 'Brunello di Montalcino',
                        localizedName: 'Brunello di Montalcino',
                        desciption: '',
                    },
                    Campania: {
                        name: 'Campania',
                        localizedName: 'Campania',
                        desciption: '',
                    },
                    Capri: {
                        name: 'Capri',
                        localizedName: 'Capri',
                        desciption: '',
                    },
                    Carema: {
                        name: 'Carema',
                        localizedName: 'Carema',
                        desciption: '',
                    },
                    'Chianti Classico Gran Selezione': {
                        name: 'Chianti Classico Gran Selezione',
                        localizedName: 'Chianti Classico Gran Selezione',
                        desciption: '',
                    },
                    'Colli di Luni': {
                        name: 'Colli di Luni',
                        localizedName: 'Colli di Luni',
                        desciption: '',
                    },
                    'delle Venezie': {
                        name: 'delle Venezie',
                        localizedName: 'delle Venezie',
                        desciption: '',
                    },
                    "Dolcetto d'Alba": {
                        name: "Dolcetto d'Alba",
                        localizedName: "Dolcetto d'Alba",
                        desciption: '',
                    },
                    "Dolcetto d'Ovada": {
                        name: "Dolcetto d'Ovada",
                        localizedName: "Dolcetto d'Ovada",
                        desciption: '',
                    },
                    Dolomiterna: {
                        name: 'Dolomiterna',
                        localizedName: 'Dolomiterna',
                        desciption: '',
                    },
                    'Emilia-Romagna': {
                        name: 'Emilia-Romagna',
                        localizedName: 'Emilia-Romagna',
                        desciption: '',
                    },
                    'Friuli Colli Orientali': {
                        name: 'Friuli Colli Orientali',
                        localizedName: 'Friuli Colli Orientali',
                        desciption: '',
                    },
                    'Friuli DOC': {
                        name: 'Friuli DOC',
                        localizedName: 'Friuli DOC',
                        desciption: '',
                    },
                    'Friuli-Venezia Giulia': {
                        name: 'Friuli-Venezia Giulia',
                        localizedName: 'Friuli-Venezia Giulia',
                        desciption: '',
                    },
                    'Gavi di Gavi': {
                        name: 'Gavi di Gavi',
                        localizedName: 'Gavi di Gavi',
                        desciption: '',
                    },
                    Inferno: {
                        name: 'Inferno',
                        localizedName: 'Inferno',
                        desciption: '',
                    },
                    Kalabrien: {
                        name: 'Kalabrien',
                        localizedName: 'Kalabrien',
                        desciption: '',
                        children: {
                            Bivongi: {
                                name: 'Bivongi',
                                localizedName: 'Bivongi',
                                desciption: '',
                            },
                            Cirò: {
                                name: 'Cirò',
                                localizedName: 'Cirò',
                                desciption: '',
                            },
                            Gaglioppo: {
                                name: 'Gaglioppo',
                                localizedName: 'Gaglioppo',
                                desciption: '',
                            },
                            'Greco di Bianco': {
                                name: 'Greco di Bianco',
                                localizedName: 'Greco di Bianco',
                                desciption: '',
                            },
                            Lamezia: {
                                name: 'Lamezia',
                                localizedName: 'Lamezia',
                                desciption: '',
                            },
                            Melissa: {
                                name: 'Melissa',
                                localizedName: 'Melissa',
                                desciption: '',
                            },
                            Savuto: {
                                name: 'Savuto',
                                localizedName: 'Savuto',
                                desciption: '',
                            },
                            Scavigna: {
                                name: 'Scavigna',
                                localizedName: 'Scavigna',
                                desciption: '',
                            },
                            'Terre di Cosenza': {
                                name: 'Terre di Cosenza',
                                localizedName: 'Terre di Cosenza',
                                desciption: '',
                            },
                        },
                    },
                    Kampanien: {
                        name: 'Kampanien',
                        localizedName: 'Kampanien',
                        desciption: '',
                        children: {
                            Avellino: {
                                name: 'Avellino',
                                localizedName: 'Avellino',
                                desciption: '',
                                children: {
                                    Aglianico: {
                                        name: 'Aglianico',
                                        localizedName: 'Aglianico',
                                        desciption: '',
                                    },
                                    Falanghina: {
                                        name: 'Falanghina',
                                        localizedName: 'Falanghina',
                                        desciption: '',
                                    },
                                    Fiano: {
                                        name: 'Fiano',
                                        localizedName: 'Fiano',
                                        desciption: '',
                                    },
                                    'Greco di Tufo': {
                                        name: 'Greco di Tufo',
                                        localizedName: 'Greco di Tufo',
                                        desciption: '',
                                    },
                                },
                            },
                            Benevento: {
                                name: 'Benevento',
                                localizedName: 'Benevento',
                                desciption: '',
                                children: {
                                    Aglianico: {
                                        name: 'Aglianico',
                                        localizedName: 'Aglianico',
                                        desciption: '',
                                    },
                                    Falanghina: {
                                        name: 'Falanghina',
                                        localizedName: 'Falanghina',
                                        desciption: '',
                                    },
                                    Solopaca: {
                                        name: 'Solopaca',
                                        localizedName: 'Solopaca',
                                        desciption: '',
                                    },
                                },
                            },
                            Caserta: {
                                name: 'Caserta',
                                localizedName: 'Caserta',
                                desciption: '',
                            },
                            Napoli: {
                                name: 'Napoli',
                                localizedName: 'Napoli',
                                desciption: '',
                            },
                            Salerno: {
                                name: 'Salerno',
                                localizedName: 'Salerno',
                                desciption: '',
                            },
                        },
                    },
                    'Lambrusco Grasparossa di Castelvetro': {
                        name: 'Lambrusco Grasparossa di Castelvetro',
                        localizedName: 'Lambrusco Grasparossa di Castelvetro',
                        desciption: '',
                    },
                    Langhe: {
                        name: 'Langhe',
                        localizedName: 'Langhe',
                        desciption: '',
                    },
                    Lazio: {
                        name: 'Lazio',
                        localizedName: 'Lazio',
                        desciption: '',
                    },
                    'Liguria di Levante IGT': {
                        name: 'Liguria di Levante IGT',
                        localizedName: 'Liguria di Levante IGT',
                        desciption: '',
                    },
                    Ligurien: {
                        name: 'Ligurien',
                        localizedName: 'Ligurien',
                        desciption: '',
                    },
                    Lombardiet: {
                        name: 'Lombardiet',
                        localizedName: 'Lombardiet',
                        desciption: '',
                        children: {
                            Franciacorta: {
                                name: 'Franciacorta',
                                localizedName: 'Franciacorta',
                                desciption: '',
                            },
                            'Oltrepo Pavese': {
                                name: 'Oltrepo Pavese',
                                localizedName: 'Oltrepo Pavese',
                                desciption: '',
                            },
                        },
                    },
                    Lombardy: {
                        name: 'Lombardy',
                        localizedName: 'Lombardy',
                        desciption: '',
                    },
                    'Mamertino DOC': {
                        name: 'Mamertino DOC',
                        localizedName: 'Mamertino DOC',
                        desciption: '',
                    },
                    Manduria: {
                        name: 'Manduria',
                        localizedName: 'Manduria',
                        desciption: '',
                    },
                    Marche: {
                        name: 'Marche',
                        localizedName: 'Marche',
                        desciption: '',
                    },
                    Maremma: {
                        name: 'Maremma',
                        localizedName: 'Maremma',
                        desciption: '',
                    },
                    Modena: {
                        name: 'Modena',
                        localizedName: 'Modena',
                        desciption: '',
                    },
                    'Montepulciano d´Abruzzo': {
                        name: 'Montepulciano d´Abruzzo',
                        localizedName: 'Montepulciano d´Abruzzo',
                        desciption: '',
                    },
                    "Moscato d'Asti": {
                        name: "Moscato d'Asti",
                        localizedName: "Moscato d'Asti",
                        desciption: '',
                    },
                    "Nebbiolo d'Alba": {
                        name: "Nebbiolo d'Alba",
                        localizedName: "Nebbiolo d'Alba",
                        desciption: '',
                    },
                    Piedmont: {
                        name: 'Piedmont',
                        localizedName: 'Piedmont',
                        desciption: '',
                    },
                    "Piemonte- Barbera d'Asti": {
                        name: "Piemonte- Barbera d'Asti",
                        localizedName: "Piemonte- Barbera d'Asti",
                        desciption: '',
                    },
                    Piemonte: {
                        name: 'Piemonte',
                        localizedName: 'Piemonte',
                        desciption: '',
                        children: {
                            Acqui: {
                                name: 'Acqui',
                                localizedName: 'Acqui',
                                desciption: '',
                            },
                            Alba: {
                                name: 'Alba',
                                localizedName: 'Alba',
                                desciption: '',
                            },
                            Asti: {
                                name: 'Asti',
                                localizedName: 'Asti',
                                desciption: '',
                            },
                            Barbaresco: {
                                name: 'Barbaresco',
                                localizedName: 'Barbaresco',
                                desciption: '',
                            },
                            Barolo: {
                                name: 'Barolo',
                                localizedName: 'Barolo',
                                desciption: '',
                            },
                            'Colli Tortonesi': {
                                name: 'Colli Tortonesi',
                                localizedName: 'Colli Tortonesi',
                                desciption: '',
                            },
                            Gattinara: {
                                name: 'Gattinara',
                                localizedName: 'Gattinara',
                                desciption: '',
                            },
                            Gavi: {
                                name: 'Gavi',
                                localizedName: 'Gavi',
                                desciption: '',
                            },
                            Ghemme: {
                                name: 'Ghemme',
                                localizedName: 'Ghemme',
                                desciption: '',
                            },
                            Langhe: {
                                name: 'Langhe',
                                localizedName: 'Langhe',
                                desciption: '',
                            },
                            Monferrato: {
                                name: 'Monferrato',
                                localizedName: 'Monferrato',
                                desciption: '',
                            },
                            Nizza: {
                                name: 'Nizza',
                                localizedName: 'Nizza',
                                desciption: '',
                            },
                            Ovada: {
                                name: 'Ovada',
                                localizedName: 'Ovada',
                                desciption: '',
                            },
                            'Valle d Áosta': {
                                name: 'Valle d Áosta',
                                localizedName: 'Valle d Áosta',
                                desciption: '',
                            },
                        },
                    },
                    Piemote: {
                        name: 'Piemote',
                        localizedName: 'Piemote',
                        desciption: '',
                    },
                    'Prosecco DOC': {
                        name: 'Prosecco DOC',
                        localizedName: 'Prosecco DOC',
                        desciption: '',
                    },
                    Puglia: {
                        name: 'Puglia',
                        localizedName: 'Puglia',
                        desciption: '',
                    },
                    Puglien: {
                        name: 'Puglien',
                        localizedName: 'Puglien',
                        desciption: '',
                    },
                    Roero: {
                        name: 'Roero',
                        localizedName: 'Roero',
                        desciption: '',
                    },
                    'Rosso di Montalcino': {
                        name: 'Rosso di Montalcino',
                        localizedName: 'Rosso di Montalcino',
                        desciption: '',
                    },
                    Salento: {
                        name: 'Salento',
                        localizedName: 'Salento',
                        desciption: '',
                    },
                    'Sardinien IGT Isola dei Nuraghi': {
                        name: 'Sardinien IGT Isola dei Nuraghi',
                        localizedName: 'Sardinien IGT Isola dei Nuraghi',
                        desciption: '',
                    },
                    Sardinien: {
                        name: 'Sardinien',
                        localizedName: 'Sardinien',
                        desciption: '',
                        children: {
                            Cagliari: {
                                name: 'Cagliari',
                                localizedName: 'Cagliari',
                                desciption: '',
                            },
                            Cannonau: {
                                name: 'Cannonau',
                                localizedName: 'Cannonau',
                                desciption: '',
                            },
                            Monti: {
                                name: 'Monti',
                                localizedName: 'Monti',
                                desciption: '',
                            },
                            Nuragus: {
                                name: 'Nuragus',
                                localizedName: 'Nuragus',
                                desciption: '',
                            },
                            Ogliastra: {
                                name: 'Ogliastra',
                                localizedName: 'Ogliastra',
                                desciption: '',
                            },
                        },
                    },
                    Sassella: {
                        name: 'Sassella',
                        localizedName: 'Sassella',
                        desciption: '',
                    },
                    Sicilien: {
                        name: 'Sicilien',
                        localizedName: 'Sicilien',
                        desciption: '',
                        children: {
                            Etna: {
                                name: 'Etna',
                                localizedName: 'Etna',
                                desciption: '',
                            },
                            Noto: {
                                name: 'Noto',
                                localizedName: 'Noto',
                                desciption: '',
                            },
                            Pantelleria: {
                                name: 'Pantelleria',
                                localizedName: 'Pantelleria',
                                desciption: '',
                            },
                        },
                    },
                    Sicily: {
                        name: 'Sicily',
                        localizedName: 'Sicily',
                        desciption: '',
                    },
                    Toscana: {
                        name: 'Toscana',
                        localizedName: 'Toscana',
                        desciption: '',
                        children: {
                            Bolgheri: {
                                name: 'Bolgheri',
                                localizedName: 'Bolgheri',
                                desciption: '',
                            },
                            Carmignano: {
                                name: 'Carmignano',
                                localizedName: 'Carmignano',
                                desciption: '',
                            },
                            'Chianti Classico': {
                                name: 'Chianti Classico',
                                localizedName: 'Chianti Classico',
                                desciption: '',
                            },
                            Chianti: {
                                name: 'Chianti',
                                localizedName: 'Chianti',
                                desciption: '',
                            },
                            'Colli Apuani': {
                                name: 'Colli Apuani',
                                localizedName: 'Colli Apuani',
                                desciption: '',
                            },
                            'Colli Etruria Centrale': {
                                name: 'Colli Etruria Centrale',
                                localizedName: 'Colli Etruria Centrale',
                                desciption: '',
                            },
                            'Colline Lucchesi': {
                                name: 'Colline Lucchesi',
                                localizedName: 'Colline Lucchesi',
                                desciption: '',
                            },
                            Elba: {
                                name: 'Elba',
                                localizedName: 'Elba',
                                desciption: '',
                            },
                            Montalcino: {
                                name: 'Montalcino',
                                localizedName: 'Montalcino',
                                desciption: '',
                            },
                            MonteCarlo: {
                                name: 'MonteCarlo',
                                localizedName: 'MonteCarlo',
                                desciption: '',
                            },
                            Montepulciano: {
                                name: 'Montepulciano',
                                localizedName: 'Montepulciano',
                                desciption: '',
                            },
                            Montescudaio: {
                                name: 'Montescudaio',
                                localizedName: 'Montescudaio',
                                desciption: '',
                            },
                            'Morellino di Scansano': {
                                name: 'Morellino di Scansano',
                                localizedName: 'Morellino di Scansano',
                                desciption: '',
                            },
                            Parrina: {
                                name: 'Parrina',
                                localizedName: 'Parrina',
                                desciption: '',
                            },
                            Pitigliano: {
                                name: 'Pitigliano',
                                localizedName: 'Pitigliano',
                                desciption: '',
                            },
                            'San Gimignano': {
                                name: 'San Gimignano',
                                localizedName: 'San Gimignano',
                                desciption: '',
                            },
                            'Val di Chiana': {
                                name: 'Val di Chiana',
                                localizedName: 'Val di Chiana',
                                desciption: '',
                            },
                            'Val di Cornia': {
                                name: 'Val di Cornia',
                                localizedName: 'Val di Cornia',
                                desciption: '',
                            },
                            Valdinievole: {
                                name: 'Valdinievole',
                                localizedName: 'Valdinievole',
                                desciption: '',
                            },
                            'Valle di Arbia': {
                                name: 'Valle di Arbia',
                                localizedName: 'Valle di Arbia',
                                desciption: '',
                            },
                        },
                    },
                    'Trentino-Alto Adige': {
                        name: 'Trentino-Alto Adige',
                        localizedName: 'Trentino-Alto Adige',
                        desciption: '',
                        children: {
                            'Syd tyrolen': {
                                name: 'Syd tyrolen',
                                localizedName: 'Syd tyrolen',
                                desciption: '',
                            },
                        },
                    },
                    Umbrien: {
                        name: 'Umbrien',
                        localizedName: 'Umbrien',
                        desciption: '',
                        children: {
                            Orvieto: {
                                name: 'Orvieto',
                                localizedName: 'Orvieto',
                                desciption: '',
                            },
                            Torgiano: {
                                name: 'Torgiano',
                                localizedName: 'Torgiano',
                                desciption: '',
                            },
                        },
                    },
                    Valpolicella: {
                        name: 'Valpolicella',
                        localizedName: 'Valpolicella',
                        desciption: '',
                    },
                    Valtellina: {
                        name: 'Valtellina',
                        localizedName: 'Valtellina',
                        desciption: '',
                    },
                    Veneto: {
                        name: 'Veneto',
                        localizedName: 'Veneto',
                        desciption: '',
                        children: {
                            Arcole: {
                                name: 'Arcole',
                                localizedName: 'Arcole',
                                desciption: '',
                            },
                            Bagnoli: {
                                name: 'Bagnoli',
                                localizedName: 'Bagnoli',
                                desciption: '',
                            },
                            Bardolino: {
                                name: 'Bardolino',
                                localizedName: 'Bardolino',
                                desciption: '',
                            },
                            'Bianco di Custoza': {
                                name: 'Bianco di Custoza',
                                localizedName: 'Bianco di Custoza',
                                desciption: '',
                            },
                            Breganze: {
                                name: 'Breganze',
                                localizedName: 'Breganze',
                                desciption: '',
                            },
                            'Colli Berici': {
                                name: 'Colli Berici',
                                localizedName: 'Colli Berici',
                                desciption: '',
                            },
                            'Colli di Conegliano': {
                                name: 'Colli di Conegliano',
                                localizedName: 'Colli di Conegliano',
                                desciption: '',
                            },
                            'Colli Euganei': {
                                name: 'Colli Euganei',
                                localizedName: 'Colli Euganei',
                                desciption: '',
                            },
                            Gambellara: {
                                name: 'Gambellara',
                                localizedName: 'Gambellara',
                                desciption: '',
                            },
                            Garda: {
                                name: 'Garda',
                                localizedName: 'Garda',
                                desciption: '',
                            },
                            'Lessini Durello': {
                                name: 'Lessini Durello',
                                localizedName: 'Lessini Durello',
                                desciption: '',
                            },
                            'Lison Pramaggiore': {
                                name: 'Lison Pramaggiore',
                                localizedName: 'Lison Pramaggiore',
                                desciption: '',
                            },
                            Lugana: {
                                name: 'Lugana',
                                localizedName: 'Lugana',
                                desciption: '',
                            },
                            'Montgello e Colli Asolani': {
                                name: 'Montgello e Colli Asolani',
                                localizedName: 'Montgello e Colli Asolani',
                                desciption: '',
                            },
                            Piave: {
                                name: 'Piave',
                                localizedName: 'Piave',
                                desciption: '',
                            },
                            Prosecco: {
                                name: 'Prosecco',
                                localizedName: 'Prosecco',
                                desciption: '',
                            },
                            Soave: {
                                name: 'Soave',
                                localizedName: 'Soave',
                                desciption: '',
                            },
                            Valdadige: {
                                name: 'Valdadige',
                                localizedName: 'Valdadige',
                                desciption: '',
                            },
                            Valpolicella: {
                                name: 'Valpolicella',
                                localizedName: 'Valpolicella',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            Kosovo: {
                name: 'Kosovo',
                localizedName: 'Kosovo',
                desciption: '',
            },
            Kroatien: {
                name: 'Kroatien',
                localizedName: 'Kroatien',
                desciption: '',
            },
            Lettland: {
                name: 'Lettland',
                localizedName: 'Lettland',
                desciption: '',
            },
            Liechtenstein: {
                name: 'Liechtenstein',
                localizedName: 'Liechtenstein',
                desciption: '',
            },
            Litauen: {
                name: 'Litauen',
                localizedName: 'Litauen',
                desciption: '',
            },
            Luxemburg: {
                name: 'Luxemburg',
                localizedName: 'Luxemburg',
                desciption: '',
            },
            Malta: {
                name: 'Malta',
                localizedName: 'Malta',
                desciption: '',
            },
            Moldavien: {
                name: 'Moldavien',
                localizedName: 'Moldavien',
                desciption: '',
            },
            Monaco: {
                name: 'Monaco',
                localizedName: 'Monaco',
                desciption: '',
            },
            Montenegro: {
                name: 'Montenegro',
                localizedName: 'Montenegro',
                desciption: '',
            },
            Nederländerna: {
                name: 'Nederländerna',
                localizedName: 'Nederländerna',
                desciption: '',
                children: {
                    Holland: {
                        name: 'Holland',
                        localizedName: 'Holland',
                        desciption: '',
                    },
                    HOLLAND: {
                        name: 'HOLLAND',
                        localizedName: 'HOLLAND',
                        desciption: '',
                    },
                },
            },
            Nordirland: {
                name: 'Nordirland',
                localizedName: 'Nordirland',
                desciption: '',
            },
            Nordmakedonien: {
                name: 'Nordmakedonien',
                localizedName: 'Nordmakedonien',
                desciption: '',
            },
            Norge: {
                name: 'Norge',
                localizedName: 'Norge',
                desciption: '',
            },
            Österrike: {
                name: 'Österrike',
                localizedName: 'Österrike',
                desciption: '',
                children: {
                    Austria: {
                        name: 'Austria',
                        localizedName: 'Austria',
                        desciption: '',
                    },
                    Bugenland: {
                        name: 'Bugenland',
                        localizedName: 'Bugenland',
                        desciption: '',
                    },
                    Burgenland: {
                        name: 'Burgenland',
                        localizedName: 'Burgenland',
                        desciption: '',
                    },
                    Carnuntum: {
                        name: 'Carnuntum',
                        localizedName: 'Carnuntum',
                        desciption: '',
                    },
                    'Europa Österrike': {
                        name: 'Europa Österrike',
                        localizedName: 'Europa Österrike',
                        desciption: '',
                    },
                    Kamptal: {
                        name: 'Kamptal',
                        localizedName: 'Kamptal',
                        desciption: '',
                    },
                    Kremstal: {
                        name: 'Kremstal',
                        localizedName: 'Kremstal',
                        desciption: '',
                    },
                    Niederösterreich: {
                        name: 'Niederösterreich',
                        localizedName: 'Niederösterreich',
                        desciption: '',
                    },
                    Steiermark: {
                        name: 'Steiermark',
                        localizedName: 'Steiermark',
                        desciption: '',
                    },
                    Vienna: {
                        name: 'Vienna',
                        localizedName: 'Vienna',
                        desciption: '',
                    },
                    Wachau: {
                        name: 'Wachau',
                        localizedName: 'Wachau',
                        desciption: '',
                    },
                    Wagram: {
                        name: 'Wagram',
                        localizedName: 'Wagram',
                        desciption: '',
                    },
                    Weinviertel: {
                        name: 'Weinviertel',
                        localizedName: 'Weinviertel',
                        desciption: '',
                    },
                },
            },
            Polen: {
                name: 'Polen',
                localizedName: 'Polen',
                desciption: '',
            },
            Portugal: {
                name: 'Portugal',
                localizedName: 'Portugal',
                desciption: '',
                children: {
                    Alenquer: {
                        name: 'Alenquer',
                        localizedName: 'Alenquer',
                        desciption: '',
                    },
                    Bairrada: {
                        name: 'Bairrada',
                        localizedName: 'Bairrada',
                        desciption: '',
                    },
                    Carcavelos: {
                        name: 'Carcavelos',
                        localizedName: 'Carcavelos',
                        desciption: '',
                    },
                    Dão: {
                        name: 'Dão',
                        localizedName: 'Dão',
                        desciption: '',
                    },
                    Douro: {
                        name: 'Douro',
                        localizedName: 'Douro',
                        desciption: '',
                    },
                    Duoro: {
                        name: 'Duoro',
                        localizedName: 'Duoro',
                        desciption: '',
                    },
                    Lagoa: {
                        name: 'Lagoa',
                        localizedName: 'Lagoa',
                        desciption: '',
                    },
                    Lagos: {
                        name: 'Lagos',
                        localizedName: 'Lagos',
                        desciption: '',
                    },
                    Lissabon: {
                        name: 'Lissabon',
                        localizedName: 'Lissabon',
                        desciption: '',
                    },
                    Madeira: {
                        name: 'Madeira',
                        localizedName: 'Madeira',
                        desciption: '',
                    },
                    Minho: {
                        name: 'Minho',
                        localizedName: 'Minho',
                        desciption: '',
                    },
                    Portimão: {
                        name: 'Portimão',
                        localizedName: 'Portimão',
                        desciption: '',
                    },
                    Porto: {
                        name: 'Porto',
                        localizedName: 'Porto',
                        desciption: '',
                    },
                    Setúbal: {
                        name: 'Setúbal',
                        localizedName: 'Setúbal',
                        desciption: '',
                    },
                    Tavira: {
                        name: 'Tavira',
                        localizedName: 'Tavira',
                        desciption: '',
                    },
                    Tejo: {
                        name: 'Tejo',
                        localizedName: 'Tejo',
                        desciption: '',
                    },
                    'Tras Os Montes': {
                        name: 'Tras Os Montes',
                        localizedName: 'Tras Os Montes',
                        desciption: '',
                    },
                    'Vinho Verde': {
                        name: 'Vinho Verde',
                        localizedName: 'Vinho Verde',
                        desciption: '',
                    },
                },
            },
            Rumänien: {
                name: 'Rumänien',
                localizedName: 'Rumänien',
                desciption: '',
            },
            Ryssland: {
                name: 'Ryssland',
                localizedName: 'Ryssland',
                desciption: '',
            },
            'San Marino': {
                name: 'San Marino',
                localizedName: 'San Marino',
                desciption: '',
            },
            Schweiz: {
                name: 'Schweiz',
                localizedName: 'Schweiz',
                desciption: '',
            },
            Serbien: {
                name: 'Serbien',
                localizedName: 'Serbien',
                desciption: '',
            },
            Skottland: {
                name: 'Skottland',
                localizedName: 'Skottland',
                desciption: '',
            },
            Slovakien: {
                name: 'Slovakien',
                localizedName: 'Slovakien',
                desciption: '',
            },
            Slovenien: {
                name: 'Slovenien',
                localizedName: 'Slovenien',
                desciption: '',
                children: {
                    'Vipava Valley': {
                        name: 'Vipava Valley',
                        localizedName: 'Vipava Valley',
                        desciption: '',
                    },
                },
            },
            Spanien: {
                name: 'Spanien',
                localizedName: 'Spanien',
                desciption: '',
                children: {
                    Alicante: {
                        name: 'Alicante',
                        localizedName: 'Alicante',
                        desciption: '',
                    },
                    Andalucía: {
                        name: 'Andalucía',
                        localizedName: 'Andalucía',
                        desciption: '',
                    },
                    Andalusien: {
                        name: 'Andalusien',
                        localizedName: 'Andalusien',
                        desciption: '',
                        children: {
                            Jerez: {
                                name: 'Jerez',
                                localizedName: 'Jerez',
                                desciption: '',
                            },
                            Malaga: {
                                name: 'Malaga',
                                localizedName: 'Malaga',
                                desciption: '',
                            },
                            'Montilla-Morile': {
                                name: 'Montilla-Morile',
                                localizedName: 'Montilla-Morile',
                                desciption: '',
                            },
                        },
                    },
                    Aragon: {
                        name: 'Aragon',
                        localizedName: 'Aragon',
                        desciption: '',
                    },
                    Asturias: {
                        name: 'Asturias',
                        localizedName: 'Asturias',
                        desciption: '',
                    },
                    Baskien: {
                        name: 'Baskien',
                        localizedName: 'Baskien',
                        desciption: '',
                        children: {
                            'Alavan Txakoli': {
                                name: 'Alavan Txakoli',
                                localizedName: 'Alavan Txakoli',
                                desciption: '',
                            },
                            'Biscayan Txakoli': {
                                name: 'Biscayan Txakoli',
                                localizedName: 'Biscayan Txakoli',
                                desciption: '',
                            },
                            Cava: {
                                name: 'Cava',
                                localizedName: 'Cava',
                                desciption: '',
                            },
                            'Getaria Txakoli': {
                                name: 'Getaria Txakoli',
                                localizedName: 'Getaria Txakoli',
                                desciption: '',
                            },
                        },
                    },
                    Calatayud: {
                        name: 'Calatayud',
                        localizedName: 'Calatayud',
                        desciption: '',
                    },
                    'Campo de Borja': {
                        name: 'Campo de Borja',
                        localizedName: 'Campo de Borja',
                        desciption: '',
                    },
                    Canaries: {
                        name: 'Canaries',
                        localizedName: 'Canaries',
                        desciption: '',
                        children: {
                            'El Hierro': {
                                name: 'El Hierro',
                                localizedName: 'El Hierro',
                                desciption: '',
                            },
                            'Gran Canaria': {
                                name: 'Gran Canaria',
                                localizedName: 'Gran Canaria',
                                desciption: '',
                            },
                            'La Gomera': {
                                name: 'La Gomera',
                                localizedName: 'La Gomera',
                                desciption: '',
                            },
                            'La Palma': {
                                name: 'La Palma',
                                localizedName: 'La Palma',
                                desciption: '',
                            },
                            Lanzarote: {
                                name: 'Lanzarote',
                                localizedName: 'Lanzarote',
                                desciption: '',
                            },
                            Teneriffa: {
                                name: 'Teneriffa',
                                localizedName: 'Teneriffa',
                                desciption: '',
                            },
                        },
                    },
                    'Castilla La Mancha': {
                        name: 'Castilla La Mancha',
                        localizedName: 'Castilla La Mancha',
                        desciption: '',
                        children: {
                            Manchuela: {
                                name: 'Manchuela',
                                localizedName: 'Manchuela',
                                desciption: '',
                            },
                        },
                    },
                    'Castilla y León': {
                        name: 'Castilla y León',
                        localizedName: 'Castilla y León',
                        desciption: '',
                        children: {
                            Bierzo: {
                                name: 'Bierzo',
                                localizedName: 'Bierzo',
                                desciption: '',
                            },
                            'Ribera del Duero': {
                                name: 'Ribera del Duero',
                                localizedName: 'Ribera del Duero',
                                desciption: '',
                            },
                            Rueda: {
                                name: 'Rueda',
                                localizedName: 'Rueda',
                                desciption: '',
                            },
                            Salamanca: {
                                name: 'Salamanca',
                                localizedName: 'Salamanca',
                                desciption: '',
                            },
                            'Tierra del Vino de Zamora': {
                                name: 'Tierra del Vino de Zamora',
                                localizedName: 'Tierra del Vino de Zamora',
                                desciption: '',
                            },
                            Toro: {
                                name: 'Toro',
                                localizedName: 'Toro',
                                desciption: '',
                            },
                            Valtiendas: {
                                name: 'Valtiendas',
                                localizedName: 'Valtiendas',
                                desciption: '',
                            },
                        },
                    },
                    Cataluña: {
                        name: 'Cataluña',
                        localizedName: 'Cataluña',
                        desciption: '',
                    },
                    Cava: {
                        name: 'Cava',
                        localizedName: 'Cava',
                        desciption: '',
                    },
                    'Conca de Barbera': {
                        name: 'Conca de Barbera',
                        localizedName: 'Conca de Barbera',
                        desciption: '',
                    },
                    Estremadura: {
                        name: 'Estremadura',
                        localizedName: 'Estremadura',
                        desciption: '',
                    },
                    Extremadura: {
                        name: 'Extremadura',
                        localizedName: 'Extremadura',
                        desciption: '',
                    },
                    Galicia: {
                        name: 'Galicia',
                        localizedName: 'Galicia',
                        desciption: '',
                    },
                    Galicien: {
                        name: 'Galicien',
                        localizedName: 'Galicien',
                        desciption: '',
                        children: {
                            Monterrei: {
                                name: 'Monterrei',
                                localizedName: 'Monterrei',
                                desciption: '',
                            },
                            'Rias Baixas': {
                                name: 'Rias Baixas',
                                localizedName: 'Rias Baixas',
                                desciption: '',
                            },
                            'Ribeira Sacra': {
                                name: 'Ribeira Sacra',
                                localizedName: 'Ribeira Sacra',
                                desciption: '',
                            },
                            Ribeiro: {
                                name: 'Ribeiro',
                                localizedName: 'Ribeiro',
                                desciption: '',
                            },
                            Valdeorras: {
                                name: 'Valdeorras',
                                localizedName: 'Valdeorras',
                                desciption: '',
                            },
                        },
                    },
                    Gredos: {
                        name: 'Gredos',
                        localizedName: 'Gredos',
                        desciption: '',
                    },
                    'Islas Baleares': {
                        name: 'Islas Baleares',
                        localizedName: 'Islas Baleares',
                        desciption: '',
                    },
                    Jumilla: {
                        name: 'Jumilla',
                        localizedName: 'Jumilla',
                        desciption: '',
                    },
                    'Kastillien La Mancha': {
                        name: 'Kastillien La Mancha',
                        localizedName: 'Kastillien La Mancha',
                        desciption: '',
                        children: {
                            Almansa: {
                                name: 'Almansa',
                                localizedName: 'Almansa',
                                desciption: '',
                            },
                            'Dominio de Valdepusa': {
                                name: 'Dominio de Valdepusa',
                                localizedName: 'Dominio de Valdepusa',
                                desciption: '',
                            },
                            Guijoso: {
                                name: 'Guijoso',
                                localizedName: 'Guijoso',
                                desciption: '',
                            },
                            Jumilla: {
                                name: 'Jumilla',
                                localizedName: 'Jumilla',
                                desciption: '',
                            },
                            'La Mancha': {
                                name: 'La Mancha',
                                localizedName: 'La Mancha',
                                desciption: '',
                            },
                            Manchuela: {
                                name: 'Manchuela',
                                localizedName: 'Manchuela',
                                desciption: '',
                            },
                            Méntrida: {
                                name: 'Méntrida',
                                localizedName: 'Méntrida',
                                desciption: '',
                            },
                            Mondéjar: {
                                name: 'Mondéjar',
                                localizedName: 'Mondéjar',
                                desciption: '',
                            },
                            'Ribera del Júcar': {
                                name: 'Ribera del Júcar',
                                localizedName: 'Ribera del Júcar',
                                desciption: '',
                            },
                            Valdepeñas: {
                                name: 'Valdepeñas',
                                localizedName: 'Valdepeñas',
                                desciption: '',
                            },
                        },
                    },
                    Katalonien: {
                        name: 'Katalonien',
                        localizedName: 'Katalonien',
                        desciption: '',
                        children: {
                            Alella: {
                                name: 'Alella',
                                localizedName: 'Alella',
                                desciption: '',
                            },
                            Catalunya: {
                                name: 'Catalunya',
                                localizedName: 'Catalunya',
                                desciption: '',
                            },
                            Cava: {
                                name: 'Cava',
                                localizedName: 'Cava',
                                desciption: '',
                            },
                            Emporda: {
                                name: 'Emporda',
                                localizedName: 'Emporda',
                                desciption: '',
                            },
                            Montsant: {
                                name: 'Montsant',
                                localizedName: 'Montsant',
                                desciption: '',
                            },
                            Penedes: {
                                name: 'Penedes',
                                localizedName: 'Penedes',
                                desciption: '',
                            },
                            Penedès: {
                                name: 'Penedès',
                                localizedName: 'Penedès',
                                desciption: '',
                            },
                            Priorat: {
                                name: 'Priorat',
                                localizedName: 'Priorat',
                                desciption: '',
                            },
                            Tarragona: {
                                name: 'Tarragona',
                                localizedName: 'Tarragona',
                                desciption: '',
                            },
                            'Terra Alta': {
                                name: 'Terra Alta',
                                localizedName: 'Terra Alta',
                                desciption: '',
                            },
                        },
                    },
                    Madrid: {
                        name: 'Madrid',
                        localizedName: 'Madrid',
                        desciption: '',
                    },
                    Mallorca: {
                        name: 'Mallorca',
                        localizedName: 'Mallorca',
                        desciption: '',
                    },
                    Murcia: {
                        name: 'Murcia',
                        localizedName: 'Murcia',
                        desciption: '',
                    },
                    Navarra: {
                        name: 'Navarra',
                        localizedName: 'Navarra',
                        desciption: '',
                    },
                    'País Vasco': {
                        name: 'País Vasco',
                        localizedName: 'País Vasco',
                        desciption: '',
                    },
                    'Rías Baixas': {
                        name: 'Rías Baixas',
                        localizedName: 'Rías Baixas',
                        desciption: '',
                    },
                    Rioja: {
                        name: 'Rioja',
                        localizedName: 'Rioja',
                        desciption: '',
                        children: {
                            'Rioja Alavesa': {
                                name: 'Rioja Alavesa',
                                localizedName: 'Rioja Alavesa',
                                desciption: '',
                            },
                            'Rioja Alta': {
                                name: 'Rioja Alta',
                                localizedName: 'Rioja Alta',
                                desciption: '',
                            },
                            'Rioja Baja': {
                                name: 'Rioja Baja',
                                localizedName: 'Rioja Baja',
                                desciption: '',
                            },
                        },
                    },
                    'Sanlucar de Barrameda': {
                        name: 'Sanlucar de Barrameda',
                        localizedName: 'Sanlucar de Barrameda',
                        desciption: '',
                    },
                    'Sierra de Gredos': {
                        name: 'Sierra de Gredos',
                        localizedName: 'Sierra de Gredos',
                        desciption: '',
                    },
                    'Terra Alta': {
                        name: 'Terra Alta',
                        localizedName: 'Terra Alta',
                        desciption: '',
                    },
                    'Utiel-Requena': {
                        name: 'Utiel-Requena',
                        localizedName: 'Utiel-Requena',
                        desciption: '',
                    },
                    Valencia: {
                        name: 'Valencia',
                        localizedName: 'Valencia',
                        desciption: '',
                    },
                    'Viños de Madrid': {
                        name: 'Viños de Madrid',
                        localizedName: 'Viños de Madrid',
                        desciption: '',
                    },
                },
            },
            Sverige: {
                name: 'Sverige',
                localizedName: 'Sverige',
                desciption: '',
                children: {
                    Bjäre: {
                        name: 'Bjäre',
                        localizedName: 'Bjäre',
                        desciption: '',
                    },
                    Blekinge: {
                        name: 'Blekinge',
                        localizedName: 'Blekinge',
                        desciption: '',
                    },
                    Bohuslän: {
                        name: 'Bohuslän',
                        localizedName: 'Bohuslän',
                        desciption: '',
                    },
                    Eskilstuna: {
                        name: 'Eskilstuna',
                        localizedName: 'Eskilstuna',
                        desciption: '',
                    },
                    Gävle: {
                        name: 'Gävle',
                        localizedName: 'Gävle',
                        desciption: '',
                    },
                    Göteborg: {
                        name: 'Göteborg',
                        localizedName: 'Göteborg',
                        desciption: '',
                    },
                    Halland: {
                        name: 'Halland',
                        localizedName: 'Halland',
                        desciption: '',
                    },
                    Helsingborg: {
                        name: 'Helsingborg',
                        localizedName: 'Helsingborg',
                        desciption: '',
                    },
                    Jämtland: {
                        name: 'Jämtland',
                        localizedName: 'Jämtland',
                        desciption: '',
                    },
                    Malmö: {
                        name: 'Malmö',
                        localizedName: 'Malmö',
                        desciption: '',
                    },
                    Närke: {
                        name: 'Närke',
                        localizedName: 'Närke',
                        desciption: '',
                    },
                    'Roslagsfisk/Rökeri': {
                        name: 'Roslagsfisk/Rökeri',
                        localizedName: 'Roslagsfisk/Rökeri',
                        desciption: '',
                    },
                    Skåne: {
                        name: 'Skåne',
                        localizedName: 'Skåne',
                        desciption: '',
                        children: {
                            Österlen: {
                                name: 'Österlen',
                                localizedName: 'Österlen',
                                desciption: '',
                            },
                        },
                    },
                    Småland: {
                        name: 'Småland',
                        localizedName: 'Småland',
                        desciption: '',
                    },
                    Södermanland: {
                        name: 'Södermanland',
                        localizedName: 'Södermanland',
                        desciption: '',
                    },
                    Stockholm: {
                        name: 'Stockholm',
                        localizedName: 'Stockholm',
                        desciption: '',
                    },
                    Strömstad: {
                        name: 'Strömstad',
                        localizedName: 'Strömstad',
                        desciption: '',
                    },
                    Umeå: {
                        name: 'Umeå',
                        localizedName: 'Umeå',
                        desciption: '',
                    },
                    Uppsala: {
                        name: 'Uppsala',
                        localizedName: 'Uppsala',
                        desciption: '',
                    },
                    Västerås: {
                        name: 'Västerås',
                        localizedName: 'Västerås',
                        desciption: '',
                    },
                    Västergötland: {
                        name: 'Västergötland',
                        localizedName: 'Västergötland',
                        desciption: '',
                    },
                    Västmanland: {
                        name: 'Västmanland',
                        localizedName: 'Västmanland',
                        desciption: '',
                    },
                    Östergötland: {
                        name: 'Östergötland',
                        localizedName: 'Östergötland',
                        desciption: '',
                    },
                },
            },
            Tjeckien: {
                name: 'Tjeckien',
                localizedName: 'Tjeckien',
                desciption: '',
            },
            Turkiet: {
                name: 'Turkiet',
                localizedName: 'Turkiet',
                desciption: '',
            },
            Tyskland: {
                name: 'Tyskland',
                localizedName: 'Tyskland',
                desciption: '',
                children: {
                    Ahr: {
                        name: 'Ahr',
                        localizedName: 'Ahr',
                        desciption: '',
                    },
                    Baden: {
                        name: 'Baden',
                        localizedName: 'Baden',
                        desciption: '',
                    },
                    Bavaria: {
                        name: 'Bavaria',
                        localizedName: 'Bavaria',
                        desciption: '',
                    },
                    Bayern: {
                        name: 'Bayern',
                        localizedName: 'Bayern',
                        desciption: '',
                    },
                    'Deutscher Sekt': {
                        name: 'Deutscher Sekt',
                        localizedName: 'Deutscher Sekt',
                        desciption: '',
                    },
                    Franken: {
                        name: 'Franken',
                        localizedName: 'Franken',
                        desciption: '',
                    },
                    Germany: {
                        name: 'Germany',
                        localizedName: 'Germany',
                        desciption: '',
                    },
                    'Hessische Bergstrasse': {
                        name: 'Hessische Bergstrasse',
                        localizedName: 'Hessische Bergstrasse',
                        desciption: '',
                    },
                    'Kernen-Stetten': {
                        name: 'Kernen-Stetten',
                        localizedName: 'Kernen-Stetten',
                        desciption: '',
                    },
                    Mittelrhein: {
                        name: 'Mittelrhein',
                        localizedName: 'Mittelrhein',
                        desciption: '',
                    },
                    'Mosel-Saar-Ruwer': {
                        name: 'Mosel-Saar-Ruwer',
                        localizedName: 'Mosel-Saar-Ruwer',
                        desciption: '',
                    },
                    Mosel: {
                        name: 'Mosel',
                        localizedName: 'Mosel',
                        desciption: '',
                    },
                    Nahe: {
                        name: 'Nahe',
                        localizedName: 'Nahe',
                        desciption: '',
                    },
                    Pfalz: {
                        name: 'Pfalz',
                        localizedName: 'Pfalz',
                        desciption: '',
                    },
                    Rheingau: {
                        name: 'Rheingau',
                        localizedName: 'Rheingau',
                        desciption: '',
                    },
                    Rheinhessen: {
                        name: 'Rheinhessen',
                        localizedName: 'Rheinhessen',
                        desciption: '',
                    },
                    'Saale-Unstrut': {
                        name: 'Saale-Unstrut',
                        localizedName: 'Saale-Unstrut',
                        desciption: '',
                    },
                    Sachsen: {
                        name: 'Sachsen',
                        localizedName: 'Sachsen',
                        desciption: '',
                    },
                    Württemberg: {
                        name: 'Württemberg',
                        localizedName: 'Württemberg',
                        desciption: '',
                    },
                },
            },
            Ukraina: {
                name: 'Ukraina',
                localizedName: 'Ukraina',
                desciption: '',
            },
            Ungern: {
                name: 'Ungern',
                localizedName: 'Ungern',
                desciption: '',
                children: {
                    Tokaji: {
                        name: 'Tokaji',
                        localizedName: 'Tokaji',
                        desciption: '',
                    },
                },
            },
            Vatikanstaten: {
                name: 'Vatikanstaten',
                localizedName: 'Vatikanstaten',
                desciption: '',
            },
            Wales: {
                name: 'Wales',
                localizedName: 'Wales',
                desciption: '',
            },
        },
    },
    Karibien: {
        name: 'Karibien',
        localizedName: 'Karibien',
        desciption: '',
        children: {
            'Antigua och Barbuda': {
                name: 'Antigua och Barbuda',
                localizedName: 'Antigua och Barbuda',
                desciption: '',
            },
            Bahamas: {
                name: 'Bahamas',
                localizedName: 'Bahamas',
                desciption: '',
            },
            Barbados: {
                name: 'Barbados',
                localizedName: 'Barbados',
                desciption: '',
            },
            Bermuda: {
                name: 'Bermuda',
                localizedName: 'Bermuda',
                desciption: '',
            },
            Dominica: {
                name: 'Dominica',
                localizedName: 'Dominica',
                desciption: '',
            },
            'Dominikanska republiken': {
                name: 'Dominikanska republiken',
                localizedName: 'Dominikanska republiken',
                desciption: '',
            },
            Grenada: {
                name: 'Grenada',
                localizedName: 'Grenada',
                desciption: '',
            },
            Haiti: {
                name: 'Haiti',
                localizedName: 'Haiti',
                desciption: '',
            },
            Jamaica: {
                name: 'Jamaica',
                localizedName: 'Jamaica',
                desciption: '',
            },
            Karibien: {
                name: 'Karibien',
                localizedName: 'Karibien',
                desciption: '',
                children: {
                    Karibien: {
                        name: 'Karibien',
                        localizedName: 'Karibien',
                        desciption: '',
                    },
                },
            },
            Kuba: {
                name: 'Kuba',
                localizedName: 'Kuba',
                desciption: '',
            },
            'Puerto Rico': {
                name: 'Puerto Rico',
                localizedName: 'Puerto Rico',
                desciption: '',
            },
            'Saint Kitts och Nevis': {
                name: 'Saint Kitts och Nevis',
                localizedName: 'Saint Kitts och Nevis',
                desciption: '',
            },
            'Saint Lucia': {
                name: 'Saint Lucia',
                localizedName: 'Saint Lucia',
                desciption: '',
            },
            'Saint Vincent och Grenadinerna': {
                name: 'Saint Vincent och Grenadinerna',
                localizedName: 'Saint Vincent och Grenadinerna',
                desciption: '',
            },
            'Trinidad och Tobago': {
                name: 'Trinidad och Tobago',
                localizedName: 'Trinidad och Tobago',
                desciption: '',
            },
        },
    },
    Nordamerika: {
        name: 'Nordamerika',
        localizedName: 'Nordamerika',
        desciption: '',
        children: {
            Aruba: {
                name: 'Aruba',
                localizedName: 'Aruba',
                desciption: '',
                children: {
                    Aruba: {
                        name: 'Aruba',
                        localizedName: 'Aruba',
                        desciption: '',
                    },
                },
            },
            Grönland: {
                name: 'Grönland',
                localizedName: 'Grönland',
                desciption: '',
                children: {
                    Grönland: {
                        name: 'Grönland',
                        localizedName: 'Grönland',
                        desciption: '',
                    },
                },
            },
            Guadeloupe: {
                name: 'Guadeloupe',
                localizedName: 'Guadeloupe',
                desciption: '',
                children: {
                    Guadeloupe: {
                        name: 'Guadeloupe',
                        localizedName: 'Guadeloupe',
                        desciption: '',
                    },
                },
            },
            Kanada: {
                name: 'Kanada',
                localizedName: 'Kanada',
                desciption: '',
                children: {
                    'Niagara Peninsula': {
                        name: 'Niagara Peninsula',
                        localizedName: 'Niagara Peninsula',
                        desciption: '',
                    },
                },
            },
            Martinique: {
                name: 'Martinique',
                localizedName: 'Martinique',
                desciption: '',
                children: {
                    Martinique: {
                        name: 'Martinique',
                        localizedName: 'Martinique',
                        desciption: '',
                    },
                },
            },
            Mexiko: {
                name: 'Mexiko',
                localizedName: 'Mexiko',
                desciption: '',
            },
            'Saint-Pierre och Miquelon': {
                name: 'Saint-Pierre och Miquelon',
                localizedName: 'Saint-Pierre och Miquelon',
                desciption: '',
                children: {
                    'Saint-Pierre och Miquelon': {
                        name: 'Saint-Pierre och Miquelon',
                        localizedName: 'Saint-Pierre och Miquelon',
                        desciption: '',
                    },
                },
            },
            Storbritannien: {
                name: 'Storbritannien',
                localizedName: 'Storbritannien',
                desciption: '',
                children: {
                    'Brittiska Jungfruöarna': {
                        name: 'Brittiska Jungfruöarna',
                        localizedName: 'Brittiska Jungfruöarna',
                        desciption: '',
                    },
                },
            },
            USA: {
                name: 'USA',
                localizedName: 'USA',
                desciption: '',
                children: {
                    'Alexander Valley': {
                        name: 'Alexander Valley',
                        localizedName: 'Alexander Valley',
                        desciption: '',
                    },
                    'Amerikanska Jungfruöarna': {
                        name: 'Amerikanska Jungfruöarna',
                        localizedName: 'Amerikanska Jungfruöarna',
                        desciption: '',
                    },
                    'AVA Sta Rita Hills': {
                        name: 'AVA Sta Rita Hills',
                        localizedName: 'AVA Sta Rita Hills',
                        desciption: '',
                    },
                    'Central Coast': {
                        name: 'Central Coast',
                        localizedName: 'Central Coast',
                        desciption: '',
                    },
                    'Central Valley': {
                        name: 'Central Valley',
                        localizedName: 'Central Valley',
                        desciption: '',
                        children: {
                            'Sacramento Valley': {
                                name: 'Sacramento Valley',
                                localizedName: 'Sacramento Valley',
                                desciption: '',
                            },
                        },
                    },
                    'Columbia Valley Washington State': {
                        name: 'Columbia Valley Washington State',
                        localizedName: 'Columbia Valley Washington State',
                        desciption: '',
                    },
                    'Columbia Valley': {
                        name: 'Columbia Valley',
                        localizedName: 'Columbia Valley',
                        desciption: '',
                    },
                    Kalifornien: {
                        name: 'Kalifornien',
                        localizedName: 'Kalifornien',
                        desciption: '',
                    },
                    'New York': {
                        name: 'New York',
                        localizedName: 'New York',
                        desciption: '',
                    },
                    'North Coast': {
                        name: 'North Coast',
                        localizedName: 'North Coast',
                        desciption: '',
                        children: {
                            'Lake County': {
                                name: 'Lake County',
                                localizedName: 'Lake County',
                                desciption: '',
                            },
                            'Mendocino County': {
                                name: 'Mendocino County',
                                localizedName: 'Mendocino County',
                                desciption: '',
                                children: {
                                    'Anderson Valley': {
                                        name: 'Anderson Valley',
                                        localizedName: 'Anderson Valley',
                                        desciption: '',
                                    },
                                },
                            },
                            'Napa Valley': {
                                name: 'Napa Valley',
                                localizedName: 'Napa Valley',
                                desciption: '',
                            },
                            'Sonoma County': {
                                name: 'Sonoma County',
                                localizedName: 'Sonoma County',
                                desciption: '',
                                children: {
                                    'Russian River Valley': {
                                        name: 'Russian River Valley',
                                        localizedName: 'Russian River Valley',
                                        desciption: '',
                                    },
                                },
                            },
                        },
                    },
                    Oregon: {
                        name: 'Oregon',
                        localizedName: 'Oregon',
                        desciption: '',
                        children: {
                            'Willamette Valley': {
                                name: 'Willamette Valley',
                                localizedName: 'Willamette Valley',
                                desciption: '',
                                children: {
                                    'Eola-Amity Hills': {
                                        name: 'Eola-Amity Hills',
                                        localizedName: 'Eola-Amity Hills',
                                        desciption: '',
                                    },
                                },
                            },
                        },
                    },
                    'Paso Robles': {
                        name: 'Paso Robles',
                        localizedName: 'Paso Robles',
                        desciption: '',
                    },
                    'Santa Barbara County': {
                        name: 'Santa Barbara County',
                        localizedName: 'Santa Barbara County',
                        desciption: '',
                    },
                    'Santa Barbara': {
                        name: 'Santa Barbara',
                        localizedName: 'Santa Barbara',
                        desciption: '',
                    },
                    'Santa Maria Valley': {
                        name: 'Santa Maria Valley',
                        localizedName: 'Santa Maria Valley',
                        desciption: '',
                    },
                    'Santa Rita Hills': {
                        name: 'Santa Rita Hills',
                        localizedName: 'Santa Rita Hills',
                        desciption: '',
                    },
                    'Santa Rosa': {
                        name: 'Santa Rosa',
                        localizedName: 'Santa Rosa',
                        desciption: '',
                    },
                    'Sierra Foothills': {
                        name: 'Sierra Foothills',
                        localizedName: 'Sierra Foothills',
                        desciption: '',
                    },
                    'Sonoma Coast': {
                        name: 'Sonoma Coast',
                        localizedName: 'Sonoma Coast',
                        desciption: '',
                    },
                    'Sonoma County - Carneros': {
                        name: 'Sonoma County - Carneros',
                        localizedName: 'Sonoma County - Carneros',
                        desciption: '',
                    },
                    'South Coast': {
                        name: 'South Coast',
                        localizedName: 'South Coast',
                        desciption: '',
                        children: {
                            Riverside: {
                                name: 'Riverside',
                                localizedName: 'Riverside',
                                desciption: '',
                            },
                            'San Bernadinområdet': {
                                name: 'San Bernadinområdet',
                                localizedName: 'San Bernadinområdet',
                                desciption: '',
                            },
                        },
                    },
                    'Washington D': {
                        C: {
                            name: 'Washington D.C',
                            localizedName: 'Washington D.C',
                            desciption: '',
                        },
                    },
                    Washington: {
                        name: 'Washington',
                        localizedName: 'Washington',
                        desciption: '',
                    },
                    'Wines of California': {
                        name: 'Wines of California',
                        localizedName: 'Wines of California',
                        desciption: '',
                    },
                },
            },
        },
    },
    Oceanien: {
        name: 'Oceanien',
        localizedName: 'Oceanien',
        desciption: '',
        children: {
            Australien: {
                name: 'Australien',
                localizedName: 'Australien',
                desciption: '',
                children: {
                    'Barossa Valley': {
                        name: 'Barossa Valley',
                        localizedName: 'Barossa Valley',
                        desciption: '',
                    },
                    Canberra: {
                        name: 'Canberra',
                        localizedName: 'Canberra',
                        desciption: '',
                    },
                    'New South Wales': {
                        name: 'New South Wales',
                        localizedName: 'New South Wales',
                        desciption: '',
                        children: {
                            'Hunter Valley': {
                                name: 'Hunter Valley',
                                localizedName: 'Hunter Valley',
                                desciption: '',
                            },
                            Orange: {
                                name: 'Orange',
                                localizedName: 'Orange',
                                desciption: '',
                            },
                        },
                    },
                    Rutherglen: {
                        name: 'Rutherglen',
                        localizedName: 'Rutherglen',
                        desciption: '',
                    },
                    'South Australia': {
                        name: 'South Australia',
                        localizedName: 'South Australia',
                        desciption: '',
                        children: {
                            'Adelaide Hills': {
                                name: 'Adelaide Hills',
                                localizedName: 'Adelaide Hills',
                                desciption: '',
                            },
                            Barossa: {
                                name: 'Barossa',
                                localizedName: 'Barossa',
                                desciption: '',
                            },
                            'Clare Valley': {
                                name: 'Clare Valley',
                                localizedName: 'Clare Valley',
                                desciption: '',
                            },
                            'Eden Valley': {
                                name: 'Eden Valley',
                                localizedName: 'Eden Valley',
                                desciption: '',
                            },
                            'McLaren Vale': {
                                name: 'McLaren Vale',
                                localizedName: 'McLaren Vale',
                                desciption: '',
                            },
                        },
                    },
                    Tasmanien: {
                        name: 'Tasmanien',
                        localizedName: 'Tasmanien',
                        desciption: '',
                    },
                    Victoria: {
                        name: 'Victoria',
                        localizedName: 'Victoria',
                        desciption: '',
                        children: {
                            Beechworth: {
                                name: 'Beechworth',
                                localizedName: 'Beechworth',
                                desciption: '',
                            },
                            'Mornington Peninsula': {
                                name: 'Mornington Peninsula',
                                localizedName: 'Mornington Peninsula',
                                desciption: '',
                            },
                        },
                    },
                    'Western Australia': {
                        name: 'Western Australia',
                        localizedName: 'Western Australia',
                        desciption: '',
                        children: {
                            'Margaret River': {
                                name: 'Margaret River',
                                localizedName: 'Margaret River',
                                desciption: '',
                            },
                        },
                    },
                    'Yarra Valley': {
                        name: 'Yarra Valley',
                        localizedName: 'Yarra Valley',
                        desciption: '',
                    },
                },
            },
            Fiji: {
                name: 'Fiji',
                localizedName: 'Fiji',
                desciption: '',
            },
            'Franska Polynesien': {
                name: 'Franska Polynesien',
                localizedName: 'Franska Polynesien',
                desciption: '',
                children: {
                    'Franska Polynesien': {
                        name: 'Franska Polynesien',
                        localizedName: 'Franska Polynesien',
                        desciption: '',
                    },
                },
            },
            Kiribati: {
                name: 'Kiribati',
                localizedName: 'Kiribati',
                desciption: '',
            },
            Marshallöarna: {
                name: 'Marshallöarna',
                localizedName: 'Marshallöarna',
                desciption: '',
            },
            'Mikronesiens federerade stater': {
                name: 'Mikronesiens federerade stater',
                localizedName: 'Mikronesiens federerade stater',
                desciption: '',
            },
            Nauru: {
                name: 'Nauru',
                localizedName: 'Nauru',
                desciption: '',
            },
            'Nya Zeeland': {
                name: 'Nya Zeeland',
                localizedName: 'Nya Zeeland',
                desciption: '',
                children: {
                    'Awatere Valley': {
                        name: 'Awatere Valley',
                        localizedName: 'Awatere Valley',
                        desciption: '',
                    },
                    Gisbourne: {
                        name: 'Gisbourne',
                        localizedName: 'Gisbourne',
                        desciption: '',
                    },
                    Marlborough: {
                        name: 'Marlborough',
                        localizedName: 'Marlborough',
                        desciption: '',
                    },
                    'New Zealand': {
                        name: 'New Zealand',
                        localizedName: 'New Zealand',
                        desciption: '',
                    },
                },
            },
            Palau: {
                name: 'Palau',
                localizedName: 'Palau',
                desciption: '',
            },
            'Papua Nya Guinea': {
                name: 'Papua Nya Guinea',
                localizedName: 'Papua Nya Guinea',
                desciption: '',
            },
            Pitcairnöarna: {
                name: 'Pitcairnöarna',
                localizedName: 'Pitcairnöarna',
                desciption: '',
                children: {
                    Pitcairnöarna: {
                        name: 'Pitcairnöarna',
                        localizedName: 'Pitcairnöarna',
                        desciption: '',
                    },
                },
            },
            Salomonöarna: {
                name: 'Salomonöarna',
                localizedName: 'Salomonöarna',
                desciption: '',
            },
            Samoa: {
                name: 'Samoa',
                localizedName: 'Samoa',
                desciption: '',
            },
            'South Australia': {
                name: 'South Australia',
                localizedName: 'South Australia',
                desciption: '',
            },
            Tonga: {
                name: 'Tonga',
                localizedName: 'Tonga',
                desciption: '',
            },
            Tuvalu: {
                name: 'Tuvalu',
                localizedName: 'Tuvalu',
                desciption: '',
            },
            Vanuatu: {
                name: 'Vanuatu',
                localizedName: 'Vanuatu',
                desciption: '',
            },
        },
    },
    Sydamerika: {
        name: 'Sydamerika',
        localizedName: 'Sydamerika',
        desciption: '',
        children: {
            Argentina: {
                name: 'Argentina',
                localizedName: 'Argentina',
                desciption: '',
                children: {
                    'Aconcagua Costa': {
                        name: 'Aconcagua Costa',
                        localizedName: 'Aconcagua Costa',
                        desciption: '',
                    },
                    Cuyo: {
                        name: 'Cuyo',
                        localizedName: 'Cuyo',
                        desciption: '',
                        children: {
                            'La Rioja': {
                                name: 'La Rioja',
                                localizedName: 'La Rioja',
                                desciption: '',
                            },
                            Mendoza: {
                                name: 'Mendoza',
                                localizedName: 'Mendoza',
                                desciption: '',
                            },
                            'San Juan': {
                                name: 'San Juan',
                                localizedName: 'San Juan',
                                desciption: '',
                            },
                        },
                    },
                    'Luján de Cuyo': {
                        name: 'Luján de Cuyo',
                        localizedName: 'Luján de Cuyo',
                        desciption: '',
                    },
                    North: {
                        name: 'North',
                        localizedName: 'North',
                        desciption: '',
                        children: {
                            Catamarca: {
                                name: 'Catamarca',
                                localizedName: 'Catamarca',
                                desciption: '',
                            },
                            'Salta / Cafayate': {
                                name: 'Salta / Cafayate',
                                localizedName: 'Salta / Cafayate',
                                desciption: '',
                            },
                        },
                    },
                    Patagonia: {
                        name: 'Patagonia',
                        localizedName: 'Patagonia',
                        desciption: '',
                        children: {
                            'La Pampa': {
                                name: 'La Pampa',
                                localizedName: 'La Pampa',
                                desciption: '',
                            },
                            Neuquén: {
                                name: 'Neuquén',
                                localizedName: 'Neuquén',
                                desciption: '',
                            },
                            'Rio Negro': {
                                name: 'Rio Negro',
                                localizedName: 'Rio Negro',
                                desciption: '',
                            },
                        },
                    },
                    Patagonien: {
                        name: 'Patagonien',
                        localizedName: 'Patagonien',
                        desciption: '',
                    },
                },
            },
            Bolivia: {
                name: 'Bolivia',
                localizedName: 'Bolivia',
                desciption: '',
            },
            Brasilien: {
                name: 'Brasilien',
                localizedName: 'Brasilien',
                desciption: '',
            },
            Chile: {
                name: 'Chile',
                localizedName: 'Chile',
                desciption: '',
                children: {
                    Aconcagua: {
                        name: 'Aconcagua',
                        localizedName: 'Aconcagua',
                        desciption: '',
                        children: {
                            Zapallar: {
                                name: 'Zapallar',
                                localizedName: 'Zapallar',
                                desciption: '',
                            },
                        },
                    },
                    'Casablanca Valley': {
                        name: 'Casablanca Valley',
                        localizedName: 'Casablanca Valley',
                        desciption: '',
                    },
                    'Central Valley': {
                        name: 'Central Valley',
                        localizedName: 'Central Valley',
                        desciption: '',
                    },
                    'Colchagua Valley': {
                        name: 'Colchagua Valley',
                        localizedName: 'Colchagua Valley',
                        desciption: '',
                    },
                    Itata: {
                        name: 'Itata',
                        localizedName: 'Itata',
                        desciption: '',
                    },
                    'Maipo Valley': {
                        name: 'Maipo Valley',
                        localizedName: 'Maipo Valley',
                        desciption: '',
                    },
                    'Maule Valley': {
                        name: 'Maule Valley',
                        localizedName: 'Maule Valley',
                        desciption: '',
                    },
                    'Rapel Valley': {
                        name: 'Rapel Valley',
                        localizedName: 'Rapel Valley',
                        desciption: '',
                        children: {
                            Colchagua: {
                                name: 'Colchagua',
                                localizedName: 'Colchagua',
                                desciption: '',
                                children: {
                                    Lolol: {
                                        name: 'Lolol',
                                        localizedName: 'Lolol',
                                        desciption: '',
                                    },
                                },
                            },
                        },
                    },
                },
            },
            Colombia: {
                name: 'Colombia',
                localizedName: 'Colombia',
                desciption: '',
            },
            Ecuador: {
                name: 'Ecuador',
                localizedName: 'Ecuador',
                desciption: '',
            },
            Guatemala: {
                name: 'Guatemala',
                localizedName: 'Guatemala',
                desciption: '',
            },
            Guyana: {
                name: 'Guyana',
                localizedName: 'Guyana',
                desciption: '',
            },
            Paraguay: {
                name: 'Paraguay',
                localizedName: 'Paraguay',
                desciption: '',
            },
            Peru: {
                name: 'Peru',
                localizedName: 'Peru',
                desciption: '',
            },
            Surinam: {
                name: 'Surinam',
                localizedName: 'Surinam',
                desciption: '',
            },
            Uruguay: {
                name: 'Uruguay',
                localizedName: 'Uruguay',
                desciption: '',
            },
            Venezuela: {
                name: 'Venezuela',
                localizedName: 'Venezuela',
                desciption: '',
            },
        },
    },
};
